<template>
	<div v-if="!isUploadShown" class="dragFiles" v-bind:class="{ drag: showDragDialog }" @dragenter="onDragEnter" @dragleave="onDragLeave" @drop="onDrop">
		<i class="mdi mdi-cloud-upload-outline uploadDragImage"></i>
	</div>
		<Splitter layout="vertical" :gutterSize="10" stateStorage="local" :stateKey="verticalSplitterStateKey" class="root-splitter" :class="activeTable && activeTable.hidden ? 'disabled-splitter-gutter' : ''"
			@mousedown="onSplitterMouseDown"
			@mouseup="onSplitterMouseUp"
			@resizeend="onSplitterResizeEnd"
	>
		<SplitterPanel class="inherit-height p-d-flex" :size="80" :minSize="50">
			<Splitter :gutterSize="10" stateStorage="local" stateKey="squeeze.validation.horizontalSplitterLayout" @mousedown="onSplitterMouseDown" @mouseup="onSplitterMouseUp" @resizeend="onSplitterResizeEnd">
				<SplitterPanel class="p-d-flex" :size="33" :minSize="30" ref="leftSplitterPanel">
					<div class="content" :style="{'width': leftSplitterPanelWidth > 0 ? leftSplitterPanelWidth + 'px' : '100%'}">
						<Toolbar class="p-p-2" v-if="!isEmbeddedDocumentSplit">
							<template #start>
								<Button
									v-if="hideValidationButtons"
									class="p-shadow-4 p-button-md"
									v-tooltip="$t('Squeeze.General.Back')"
									:icon="!hideValidationButtons ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-left'"
									@click="!hideValidationButtons ? goBackToValidationList() : reopenValidationView()"
								/>
								<div v-if="!hideValidationButtons">
									<Button class="p-shadow-4" v-tooltip="$t('Squeeze.Validation.Buttons.BackToList')" icon="mdi mdi-chevron-double-up" @click="goBackToValidationList" :disabled="disableBrowseButtons || exportInProgress"></Button>
									<Button class="p-shadow-4 p-ml-1" v-tooltip="$t('Squeeze.Validation.Buttons.PrevDocument')" icon="mdi mdi-chevron-left" @click="browseLeft" :disabled="disableBrowseButtons || blockBrowseButtons || exportInProgress"></Button>
									<Button class="p-shadow-4 p-ml-1" v-tooltip="$t('Squeeze.Validation.Buttons.NextDocument')" icon="mdi mdi-chevron-right" @click="goToNextDocument(false)" :disabled="disableBrowseButtons || blockBrowseButtons || exportInProgress"></Button>
								</div>
							</template>
							<template #end>
								<div v-if="hideValidationButtons && showHeadTraining || showPositionTraining || showFormHeadTraining || showFormPositionTraining || showOcrResults || showLocatorTest">
									<Button class="p-shadow-4 p-button-md" type="button" icon="mdi mdi-dots-vertical" v-tooltip="$t('Squeeze.General.Options')" @click="toggleToolBarOptions" aria-haspopup="true" aria-controls="overlayMenu" :disabled="blocked.buttons.menu" />
									<TieredMenu id="overlayTMenu1" ref="menu" :model="toolbarOptions" popup style="border:none; max-height: 80vh;" />
								</div>
								<div v-if="!hideValidationButtons">
									<Button id="btnValidation" class="p-button-md p-mr-1" :class="blocked.buttons.save ? 'p-button-text' : 'p-shadow-4'" @click="validateAndExportDocument" :label="toolbarButtonText ? validationValidateButtonSettings.description : null" :icon="validationValidateButtonSettings.icon" :style="validationValidateButtonSettings.color" :disabled="blocked.buttons.save" />
									<Button class="p-button-md p-mr-1" :class="blocked.buttons.suspend ? 'p-button-text' : 'p-shadow-4'" @click="showDialog('suspendDocument'); removeFocusOnBtnAfterClick($event);" :label="toolbarButtonText ? validationSuspendButtonSettings.description : null" :icon="validationSuspendButtonSettings.icon" :style="validationSuspendButtonSettings.color" :disabled="blocked.buttons.suspend" />
									<Button class="p-button-md p-mr-1" :class="blocked.buttons.delete ? 'p-button-text' : 'p-shadow-4'" @click="showDialog('deleteDocument'); removeFocusOnBtnAfterClick($event);" :label="toolbarButtonText ? validationDeleteButtonSettings.description : null" :icon="validationDeleteButtonSettings.icon" :style="validationDeleteButtonSettings.color" :disabled="blocked.buttons.delete" />
									<Button v-if="!autoDocumentValidation" class="p-button-md p-mr-1 p-shadow-4" v-tooltip="$t('Squeeze.Validation.Buttons.CheckDocument')" @click="validateDocument(true); removeFocusOnBtnAfterClick($event);" icon="mdi mdi-file-check-outline" severity="warning" :disabled="blocked.buttons.checkDocument" />
									<Button class="p-shadow-4 p-button-md p-mr-1" type="button" icon="mdi mdi-dots-vertical" v-tooltip="$t('Squeeze.General.Actions')" @click="toggleToolBarOptions" aria-haspopup="true" aria-controls="overlayMenu" :disabled="blocked.buttons.menu" />
									<TieredMenu id="overlayTMenu" ref="menu" :model="toolbarOptions" popup style="border:none; max-height: 80vh;" />
									<Button v-if="currentDocument?.documentType && currentDocument?.documentType !== documentTypeEnum.Pdf " class="p-shadow-4 p-button-md" type="button" icon="mdi mdi-file-question-outline" severity="secondary" v-tooltip="onHoverDocumentType(currentDocument.documentType)" :style="btnDocumentTypeBackgroundColor(currentDocument.xmlValidationState)" @click="removeFocusOnBtnAfterClick($event);" />
								</div>
							</template>
						</Toolbar>
						<hr class="horizontal-line" v-if="!isEmbeddedDocumentSplit">
						<div class="content-error-messages" v-if="currentDocument?.workflowContext?.status === 'SUSPEND' && !showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showOcrResults && !showLocatorTest && !showSplitDocument">
							<Message
								severity="warn"
								closable
							>
								<div class="p-grid p-jc-between errorMessages">
									<div class="p-col-9">
										<ul>
											<li>
												{{ $t('Squeeze.Queue.States.SUSPEND') + (currentDocument?.workflowContext?.errorText ? ': ' + currentDocument.workflowContext.errorText : '') }}
											</li>
										</ul>
									</div>
								</div>
							</Message>
						</div>
						<div class="content-error-messages" v-if="(currentDocument?.workflowContext?.step === 'Validation' || currentDocument?.workflowContext?.step === 'Auto-Validation') && !showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showOcrResults && !showLocatorTest && !showSplitDocument">
							<Message
								v-if="((currentDocument?.documentType === documentTypeEnum.Xrechnung || currentDocument?.documentType === documentTypeEnum.Zugferd) && !(currentDocument?.xmlValidationState === XmlValidationStateEnum.Valid))"
								:severity="checkSeverityForStatusMessage()"
								:closable="false"
							>
								<div class="p-grid p-jc-between errorMessages">
									<div class="p-col-9">
										<ul>
											<li v-if="currentDocument?.xmlValidationState === XmlValidationStateEnum.Invalid">
												{{ $t('Squeeze.Validation.General.DocumentXmlValidationStateInvalid') }}
											</li>
											<li v-else-if="currentDocument?.xmlValidationState === XmlValidationStateEnum.Warning">
												{{ $t('Squeeze.Validation.General.DocumentXmlValidationStateWarning') }}
											</li>
										</ul>
									</div>
									<div v-if="NEW_SQUEEZE_VIEWER" class="p-col-3 p-text-right p-as-center">
										<Button
											style="margin-right: 0;"
											icon="mdi mdi-file-eye-outline"
											v-tooltip="$t('Squeeze.Validation.General.OpenDocument')"
											:severity="checkSeverityForStatusMessage(true)"
											text rounded
											@click="changeCurrentDocumentInViewer()"
										/>
									</div>
								</div>
							</Message>
							<Message
								v-if="(currentDocument?.workflowContext?.step === 'Validation' || currentDocument?.workflowContext?.step === 'Auto-Validation') && !showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showOcrResults && !showLocatorTest && !showSplitDocument"
								:severity="checkErrorSeverity()"
								:closable="false"
							>
								<div class="p-grid p-jc-between errorMessages">
									<div class="p-col-9">
										<ul>
											<li v-if="!loaded">
												{{$t('Squeeze.General.Loading')}}
											</li>
											<li v-else-if="!currentErrorField && allErrorMessages.lengthOfAllErrors > 0">
												{{$t('Squeeze.Validation.General.PleaseCheckDocument')}}
											</li>
											<li v-else-if="!currentErrorField && allErrorMessages.lengthOfAllErrors === 0">
												{{$t('Squeeze.Validation.General.DocumentOK')}}
											</li>
											<li v-else-if="currentErrorField">
												{{ getTranslatedDescription(currentErrorField) }}:
												{{currentErrorField.value.errorText }}
											</li>
										</ul>
									</div>
									<div class="p-col-3 p-text-right p-as-center">
											<Badge v-if="allErrorMessages.lengthOfAllErrors !== 0"
												:value="loaded === false ? '?' : allErrorMessages.lengthOfAllErrors"
												:size="!toolbarButtonText ? '' : 'large'" :severity="allErrorMessages.lengthOfAllErrors === 0 ? 'success' : 'danger'"
												@mouseover="toggleErrorMessages" style="cursor: pointer"
										/>
										<OverlayPanel ref="opBadge">
											<template v-for="field in allErrorMessages.fields" v-bind:key="field.id">
												{{ getTranslatedDescription(field) }}:
												{{field.value.errorText }}<br/>
											</template>
										</OverlayPanel>
									</div>
								</div>
							</Message>
						</div>
						<div :class="showLocatorTest || showFormPositionTraining ? 'restrict-height' : (!showHeadTraining && !showPositionTraining && !showFormPositionTraining && !showOcrResults && !showLocatorTest && !showSplitDocument) ? 'content' : 'scroll-content'" ref="leftSplitterPanelContent">
							<div :class="!showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showOcrResults && !showLocatorTest && !showSplitDocument && loaded ? 'p-pl-3 p-pr-3 p-pb-3 content' :  'p-p-3 p-d-flex p-flex-column'" :style="showLocatorTest || showFormPositionTraining ? 'height: 100%;': ''">
								<HeadTraining
									v-if="showHeadTraining"
									:fieldTrainingValue="trainingValues"
									:documentClassId="documentClassId"
									:documentId="documentId"
									:documentFields="documentFields"
									:trainingKeyField="trainingKeyField"
									@onFocusField="onFocusFieldTraining"
									@onMarkRegion="onMarkRegion"
								/>
								<PositionTraining
									v-else-if="showPositionTraining"
									:documentClassId="documentClassId"
									:documentId="documentId"
									:tables="tables"
									:trainingKeyField="trainingKeyField"
									:positionTrainingValues="positionTrainingValues"
									@onChangeValues="onChangePositionTrainingValues"
									@onFocusFieldOfPositionTraining="onFocusFieldOfPositionTraining"
									@onMarkRegion="onMarkRegion"
								/>
								<FormHeadTraining
									v-else-if="showFormHeadTraining"
									:documentClassId="documentClassId"
									:documentId="documentId"
									:documentFields="documentFields"
									:trainingKeyField="trainingKeyField"
									:headFieldOfRegionInFormTraining="headFieldOfRegionInFormTraining"
									:regionAnchorOfFormTraining="regionAnchorOfFormTraining"
									@onFocusField="onFocusFieldTraining"
									@onMarkRegion="onMarkRegion"
								/>
								<FormPositionTraining
									v-else-if="showFormPositionTraining"
									:documentClassId="documentClassId"
									:documentId="documentId"
									:tables="tables"
									:trainingKeyField="trainingKeyField"
									:indicatorOfFormTraining="indicatorOfFormTraining"
									:regionAnchorOfFormTraining="regionAnchorOfFormTraining"
									:itemFieldOfRegionInFormTraining="itemFieldOfRegionInFormTraining"
									@onFocusField="onFocusFieldTraining"
									@onMarkRegion="onMarkRegion"
								/>
									<OcrView :title="$t('Squeeze.DocumentClasses.OCRResults')"
										v-else-if="showOcrResults"
										:documentId="documentId"
										@onMarkLines="onMarkLines"
										@onMarkWord="onMarkWord"
								/>
								<LocatorTesting
									v-else-if="showLocatorTest"
									:documentId="documentId"
									@onMarkWord="onMarkWord"
									:showSingleLinedForm="showLocatorTest"
								/>
								<template v-else>
									<Message v-if="embeddedLoadFailed" severity="error" :closable="false" class="p-p-2">{{ $t('Squeeze.Validation.General.DocumentLoadFailed') }}</Message>
									<!-- Split finished in the embedded, single-document flow: nothing left to browse to or show (see onEmptyList). -->
									<Message v-else-if="embeddedSplitDone" severity="success" :closable="false" class="p-p-2">{{ $t('Squeeze.Validation.Dialogs.SplitDocument.AllPagesSplit') }}</Message>
									<DocumentSplit v-else-if="showSplitDocument" :documentId="documentId" @onImageClick="onSplitImageClick" @onEmptyList="onEmptyList" @onPagesSplit="onPagesSplit" />
									<TabView v-else-if="loaded" v-model:activeIndex="activeGroupTab" @tab-change="focusOnFirstField" class="content">
										<template v-if="store.state.featureSet.validationFieldLayout">
											<TabPanel v-for="group in documentClassFieldsByGroup" :key="group.id" :header="group.description">
												<ValidationFieldSet
													:ref="el => { validationFieldSet[group.id] = el }"
													@onBlur="scheduleDocumentValidation"
													@onFocusField="markFieldByRegion"
													@allHeadRefFields="allHeadRefFields"
													@enterDocumentGroup="enterDocumentGroup"
													@onHoverItemAutocomplete="onHoverItemAutocomplete"
													class="p-mb-2"
													:documentFields="documentFields"
													:documentClassFields="group.fields"
													:id="group.id"
													:name="group.name"
													:description="group.description"
													:layoutDetails="fieldLayoutRowsByGroup[group.id ?? -1] ?? []"
													:isReadOnlyMode="isReadOnlyMode"
													:documentId="documentId"
												/>
											</TabPanel>
										</template>
										<TabPanel v-else v-for="group in documentClassFieldsByGroup" :key="group.id" :header="group.description">
											<ValidationFieldSetWithoutLayout
												:ref="el => { validationFieldSet[group.id] = el }"
												@onBlur="scheduleDocumentValidation"
												@onFocusField="markFieldByRegion"
												@allHeadRefFields="allHeadRefFields"
												@enterDocumentGroup="enterDocumentGroup"
												@onHoverItemAutocomplete="onHoverItemAutocomplete"
												class="p-mb-2"
												:documentFields="documentFields"
												:documentClassFields="group.fields"
												:id="group.id"
												:name="group.name"
												:description="group.description"
												:isReadOnlyMode="isReadOnlyMode"
												:documentId="documentId"
												:activeGroupTab="activeGroupTab"
											/>
										</TabPanel>
									</TabView>
									<TabView v-else class="p-px-2 custom">
										<TabPanel :header="$t('Squeeze.General.Loading')">
											<ValidationFieldSetSkeleton class="p-mb-2" />
										</TabPanel>
									</TabView>
								</template>
							</div>
						</div>
						<div class="p-p-2" v-if="!showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showSplitDocument && !showOcrResults && !showLocatorTest && tables.filter(t => !t.hidden).length > 1">
							<Button class="p-shadow-2 p-mr-1" v-for="table in [...tables].filter(t => !t.hidden).sort((a, b) => (a.sortOrder || 0) - (b.sortOrder))" :key="table.id" :label="getTranslatedDescription(table)" @click="setActiveTable(table.id)" />
						</div>
					</div>
				</SplitterPanel>
				<SplitterPanel class="p-d-flex" :size="67" :minSize="40">
					<div v-if="embeddedLoadFailed" class="viewer p-d-flex p-ai-center p-jc-center p-text-secondary">
						{{ $t('Squeeze.Validation.General.DocumentLoadFailed') }}
					</div>
					<div v-else-if="embeddedSplitDone" class="viewer p-d-flex p-ai-center p-jc-center p-text-secondary">
						{{ $t('Squeeze.Validation.Dialogs.SplitDocument.AllPagesSplit') }}
					</div>
					<div v-else-if="!squeezeViewerSplitterPanelReady" class="viewer p-d-flex p-ai-center p-jc-center p-text-secondary">
						{{ $t('Squeeze.General.Loading') }}
					</div>
					<div v-else-if="!NEW_SQUEEZE_VIEWER" class="viewer" ref="viewer">
						<Viewer :documentId="documentId" class="p-shadow-2" style="height: 100%" />
					</div>
					<SqueezeViewer
						v-else
						:documentData="currentDocument"
						:documentId="documentId"
						:serverBaseUrl="serverBaseUrl"
						:docBaseUrl="docBaseUrl"
						:authHeader="getUserAuth"
						:drawingMode="viewerDrawingMode"
						:selectedSpans="viewerMarkedRegions"
						:observeResizing="viewerShouldObserveResizing"
						:viewerSettings="viewerSettingsForViewer"
						:showKositValidationReportFile="showKositValidationReportFile"
						:alertMessages="viewerAlertMessages"
						ref="SqueezeViewer"
						style="height: 100%"
						@areaSelected="onViewerAreaSelected"
						@onMarkRegion="onMarkRegion"
						@toggleResultList="toggleResultList"
						@isKositValidationReportFileDisplayed="isKositValidationReportFileDisplayed"
						@clickAlertLink="onViewerClickAlertLink"
						@closeAlertMessage="onViewerCloseAlertMessage"
					/>
				</SplitterPanel>
			</Splitter>
		</SplitterPanel>
		<SplitterPanel v-if="!isEmbeddedDocumentSplit" class="p-d-flex" :minSize="25" :size="25" :style="!showTableSplitter || !showTableSplitterGutter || activeTable.hidden ? 'display: none !important' : ''">
			<div class="content" v-if="(!showHeadTraining && !showPositionTraining && !showFormHeadTraining && !showFormPositionTraining && !showSplitDocument && !showOcrResults && !showLocatorTest)">
				<div :class="['scroll-content', 'p-shadow-2', 'validation-table-panel', { 'validation-table-panel-v2': useV2ValidationTable }]">
					<div v-if="!isValidationTableLoaded" class="validation-table-loading p-p-3 p-text-center p-text-secondary">
						<div class="p-mb-2">{{ validationTableLoadingStatus }}</div>
						<ValidationFieldSetSkeleton class="p-mb-2" />
					</div>
					<component
						:is="useV2ValidationTable ? 'ValidationTableExcel' : 'ValidationTable'"
						:ref="el => { tableInValidation[activeTableId] = el }"
						v-if="validationTableMountRequested && loaded"
						:class="['p-shadow-4', { 'validation-table-hidden': !isValidationTableLoaded }]"
						@onChange="scheduleDocumentValidation"
						@onChangeTable="changeTableData"
						@loadingStatusChange="onValidationTableStatusChange"
						@mountedReady="onValidationTableMounted"
						:currentTable="findTableIndex"
						:documentFields="documentFields"
						:documentId="documentId"
						:documentClassId="documentClassId"
						:resetSelectedRows="resetSelectedRows"
						style="max-height: 100%;"
						@onFocusField="onFocusTableCell"
						@focusLastHeadField="focusLastHeadField"
						:hideButtons="hideTableButtons"
						:isReadOnlyMode="tableInteractionReadOnly"
						@allTableRefCells="allTableRefCells"
						:customTableActions="customTableActions"
						@executeCustomTableAction="executeCustomValidationAction"
					/>
				</div>
			</div>
		</SplitterPanel>
	</Splitter>

	<Sidebar v-model:visible="showHotKeyList" :baseZIndex="1000" position="right" :modal="true" :showCloseIcon="true" :dismissable="true" @hide="showHotKeyList = false">
		<HotKeyList />
	</Sidebar>

	<Dialog :header="$t('Squeeze.Validation.Log.Log')" v-model:visible="showLog" :modal="true" :closable="true" :dismissableMask="true" :baseZIndex="1000" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
		<LogView :document-id="documentId" />
	</Dialog>

	<DialogOptionsConfirm
		:show="dialogs.deleteDocument.display"
		:options="dialogs.deleteDocument.options"
		:locales="dialogs.deleteDocument.locales"
		@onConfirm="deleteDocument"
		@onClose="dialogs.deleteDocument.display = false"
	/>
	<DialogOptionsConfirm
		:show="dialogs.suspendDocument.display"
		:options="dialogs.suspendDocument.options"
		:locales="dialogs.suspendDocument.locales"
		@onConfirm="suspendDocument"
		@onClose="dialogs.suspendDocument.display = false"
		:currentDocument="currentDocument"
	/>
	<Dialog :header="$t('Squeeze.Validation.Email.SendMail')" v-model:visible="dialogs.sendMail.display" :modal="true">
		<ValidationEmailView :documentId="documentId" @sendSuccess="afterSendSuccess" :documentFields="documentFields" />
	</Dialog>

		<EntryDialog :show="dialogs.changeDocumentClass.display"
			@onClose="dialogs.changeDocumentClass.display = false"
			@onConfirm="saveNewDocumentClass"
			:headerText="$t('Squeeze.Validation.Dialogs.ChangeDocumentClass.Change')"
			:loading="dialogs.changeDocumentClass.loading"
	>
		<template #content>
			<DocumentClassChangeForm
				:classificationClasses="dialogs.changeDocumentClass.classificationClasses"
				:trainDocument="dialogs.changeDocumentClass.trainDocument"
				@onChange="onChangeDocumentClassChangeForm"
			/>
		</template>
	</EntryDialog>
	<DialogLocked
		:showDialog="dialogs.lockedDocument.display"
		:lockingUserId="lockingUserId"
		@closeDialog="dialogs.lockedDocument.display = false"
		@showOnly="onClickDocumentReadOnly()"
		@backToOverview="goBackToValidationList()"
		@unlockDocument="unlockViewedDocument()"
		@nextDocument="goToNextDocument(false)"
	/>

	<Dialog :header="$t('Squeeze.Validation.General.AddAttachment')" v-model:visible="showUpload" :modal="true" :closable="true" :dismissableMask="true" :baseZIndex="1000" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
		<FileUpload
			@select="onSelectFiles"
			name="documentFile"
			:customUpload="true"
			@uploader="fileUploader"
			:multiple="true"
			:showCancelButton="true"
			:uploadFiles="files"
			:cancelLabel="$t('Squeeze.General.Clear')"
			:customProgress="progress"
			:fileContentHeight="'15.625rem'"
			:uploadLabel="uploadLabel"
			:chooseLabel="$t('Squeeze.General.Choose')"
			@clear="clearFiles"
			@removeFile="removeFile"
			:invalidFileSizeMessage="'{0}: ' + $t('Squeeze.Validation.General.InvalidFileSize') + ' ' + '{1}'"
		/>
	</Dialog>
	<EntryDialog
		:show="showCustomActionDialog"
		@onConfirm="showCustomActionDialog = false"
		@onClose="showCustomActionDialog = false"
		:headerText="$t('PrimeVue.Message')"
		:saveButtonText="$t('Squeeze.General.Confirmation')"
		:showAbortButton="false"
	>
		<template #content>
			{{ customActionDialogMessage }}
		</template>
	</EntryDialog>
	<!--<Dialog :header="$t('Squeeze.Validation.Dialogs.SplitDocument.SplitCommand')"
			v-model:visible="showSplitDocument"
			style="width: 90%"
			position="top"
			:modal="true"
	>
		<DocumentSplit :documentId="documentId" />
	</Dialog>
	-->
	<Dialog :header="$t('Squeeze.Validation.Dialogs.ErrorDocument.Label')" v-model:visible="dialogs.errorDocument.display" :modal="true" :closable="false">
		{{ $t('Squeeze.Validation.Dialogs.ErrorDocument.Error') }}

		<template #footer>
			<Button :label="$t('Squeeze.Queue.QueueList')" icon="mdi mdi-transit-connection-horizontal" class="p-button-text p-justify-end" @click="goBackToQueueList()"/>
		</template>
	</Dialog>

	<Dialog :header="$t('Squeeze.System.Fail')" v-model:visible="showExportError" :modal="true">
		<Message
			:closable="false"
			severity="error"
		>
			{{exportErrorMessage}}
		</Message>
	</Dialog>
</template>
<script lang="ts">
/* eslint max-lines: off */
import {computed, defineComponent, nextTick, onBeforeUnmount, onMounted, PropType, reactive, ref, watch} from 'vue';
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import Toolbar from 'primevue/toolbar';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import OverlayPanel from 'primevue/overlaypanel';
import TieredMenu from 'primevue/tieredmenu';
import {AuthTypes, ClientManager} from "@/singletons/ClientManager";
import {ToastManager} from "@/util/ToastManager";
import {
	BatchClassClassification,
	BoundingBox,
	CustomValidationActionDto,
	CustomValidationActionResponseDto,
	Document,
	DocumentClassDto,
	DocumentField,
	DocumentFieldValue,
	DocumentSearchRequestDto,
	DocumentTable,
	DocumentTableCell,
	DocumentTableRow,
	DocumentValidationRequestDto,
	ErrorDto,
	FieldTraining,
	FormTrainingHeadField,
	FormTrainingItemField,
	FormTrainingItemRegionAnchor,
	FormTrainingRegionAnchor,
	PaginationDto,
	SaveValidateAndExportDocumentResponseDto,
	TableColumnTraining,
	TrainingKey,
	ValidationButtonSettingsDto,
	ValidationFieldDto,
	BannerDto,
	LinkDto
} from '@dex/squeeze-client-ts';
import ValidationFieldSet from '@/apps/squeeze/components/ValidationFieldSet.vue';
import ValidationFieldSetWithoutLayout from '@/apps/squeeze/components/ValidationFieldSetWithoutLayout.vue';
import ValidationFieldSetSkeleton from '@/apps/squeeze/components/ValidationFieldSetSkeleton.vue';
import DialogOptionsConfirm from '@/apps/squeeze/components/DialogOptionsConfirm.vue';
import Viewer from "@/apps/squeeze/components/Viewer.vue";
import {BoundingBoxOld, ViewerClient} from "@/apis/squeeze-viewer/ViewerClient";
import ValidationTable from "@/apps/squeeze/components/ValidationTable.vue";
import ValidationTableExcel from "@/apps/squeeze/components/ValidationTableExcel.vue";
import Sidebar from 'primevue/sidebar';
import ValidationEmailView from "@/apps/squeeze/views/ValidationEmailView.vue";
import Dialog from 'primevue/dialog';
import DocumentClassChangeForm from "@/apps/squeeze/components/DocumentClassChangeForm.vue";
import EntryDialog from "@/components/EntryDialog.vue";
import SinglePromise from "@/util/SinglePromise";
import DialogLocked from "@/apps/squeeze/components/DialogLocked.vue";
import HeadTraining from "@/apps/squeeze/views/HeadTraining.vue";
import DocumentSplit from "@/apps/squeeze/components/DocumentSplit.vue";
import PositionTraining from "@/apps/squeeze/views/PositionTraining.vue";
import FormHeadTraining from "@/apps/squeeze/views/FormHeadTraining.vue";
import FormPositionTraining from "@/apps/squeeze/views/FormPositionTraining.vue";
import {RouteLocationRaw, useRoute, useRouter} from "vue-router";
import {shouldUseV2ValidationTable, useSqueezeStore} from "@/apps/squeeze/store";
import OcrView from "@/apps/squeeze/views/OcrView.vue";
import LocatorTesting from "@/apps/squeeze/views/LocatorTesting.vue";
import {SqueezeViewer} from "@dex/squeeze-viewer";
import {loadBannerMessages} from "@/util/BannerHelper";
import {resolveClassSetting} from "@/util/ClassSettingsHelper";
import {dismissAlert, isAlertDismissed} from "@/util/AlertDismissHelper";
import HotKeyList from "@/apps/squeeze/components/HotKeyList.vue";
import {documentTokenUrlParam, embeddedUrlParam, viewUrlParam} from "@/util/EmbeddingParamHelper";
import Message from 'primevue/message';
import Badge from 'primevue/badge';
import {useConfirm} from "primevue/useconfirm";
import LogView from "@/apps/administration/views/squeeze/log/LogView.vue";
import FileUpload from "@/components/DexFileUpload.vue";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import {GridStackFieldDetails} from "@/apps/administration/views/squeeze/documentclasses/DocumentClassFieldsLayoutView.vue";
import {CustomAction} from "@/components/VerticalNavbar.vue";
import TableBehaviourEnum = DocumentTable.TableBehaviourEnum;
import DocumentTypeEnum = Document.DocumentTypeEnum;
import XmlValidationStateEnum = Document.XmlValidationStateEnum;
import ButtonNameEnum = ValidationButtonSettingsDto.ButtonNameEnum;
import type { DocumentClassDeleteReason } from "@dex/squeeze-client-ts";
import {TableStatus} from "@/util/TableStatus";
import {ValidationColumnWidthStore} from "@/util/ValidationColumnWidthStore";
import { TableSettings } from "@/util/TableSettings";
import {getTranslatedDescription} from "@/util/TranslationHelper";

interface DocumentClassFieldGroup {
	id: number | undefined;
	name: string;
	description: string;
	type: number;
	fields: DocumentField[] | undefined;
}

interface FieldInSameLine extends DocumentField {
	sameLineAsPreviousField?: boolean;
	colSize?: string;
	row?: number;
	offsetSize?: number;
}

interface ErrorFields {
	fields?: DocumentField[];
	lengthOfAllErrors?: number;
}

interface FieldGroupDetails {
	fieldGroupId: number;
	fieldLayout: GridStackFieldDetails[];
}

interface FieldGroupLayout {
	fieldGroupId: number;
	fieldLayout: string;
}

interface ValidationFieldLayoutDetails extends GridStackFieldDetails {
	content?: string;
	offsetSize?: number;
}

export default defineComponent({
	name: "Validation",
	components: {
		HotKeyList,
		OcrView,
		LocatorTesting,
		HeadTraining,
		PositionTraining,
		FormHeadTraining,
		FormPositionTraining,
		ValidationFieldSet,
		ValidationFieldSetWithoutLayout,
		ValidationFieldSetSkeleton,
		Viewer,
		DialogOptionsConfirm,
		ValidationTable,
		ValidationTableExcel,
		Sidebar,
		Splitter,
		SplitterPanel,
		Toolbar,
		ValidationEmailView,
		Dialog,
		DocumentClassChangeForm,
		EntryDialog,
		DialogLocked,
		DocumentSplit,
		OverlayPanel,
		TieredMenu,
		Message,
		Badge,
		LogView,
		FileUpload,
		SqueezeViewer,
		TabView,
		TabPanel,
	},
	props: {
		/** ID of document */
		documentId: {
			type: Number,
			required: true,
		},
		/** ID of document class*/
		documentClassId: {
			type: Number,
			required: true,
		},
		/** Array with the sorting of the table */
		tableSortStart: {
			type: Array as PropType<string[]>,
			default: () => [], // TODO: defaultSort?
		},
		/** Search request for document search filtering */
		searchRequest: {
			type: Object as PropType<DocumentSearchRequestDto>,
			default: () => ({}),
		},
		/** Pagination info for document search */
		pagination: {
			type: Object as PropType<PaginationDto>,
			required: true,
		},
		/** Is upload dialog shown? */
		isUploadShown: {
			type: Boolean,
			default: false,
		},
		searchId: {
			type: Number,
			default: 0,
		},
	},
	setup(props) {
		const {t, te, locale} = useI18n();
		const toast = useToast();
		const confirm = useConfirm();
		const route = useRoute();
		const router = useRouter();

		/** Current Vuex-Store */
		const store = useSqueezeStore()
		/** Incremented whenever the deferred initial validation must be invalidated. */
		let initialBackgroundValidationRunId = 0;
		/** Indicates that the initial validation should run after viewer and table became interactive. */
		let shouldRunInitialBackgroundValidation = false;
		/** Incremented whenever a scheduled validation must be invalidated. */
		let scheduledValidationRunId = 0;
		/** Current debounce timeout for scheduled validation requests. */
		let scheduledValidationTimeoutId: number | null = null;
		/** Currently running validation promise, used to serialize validation calls. */
		let activeValidationPromise: Promise<boolean> | null = null;
		/** Latest queued validation request while another validation is still running. */
		let queuedValidationRequest: { manuellyTriggered: boolean; resolvers: Array<(value: boolean) => void> } | null = null;
		/** Increment on every user edit. */
		let latestEditId = 0;
		/** AbortController of the currently validation request (so a new edit can cancel it). */
		let activeValidationAbortController: AbortController | null = null;
		/** True when a validation result was withheld because a table cell was being edited (re-validated on focus-out). */
		let hasDeferredTableValidationResult = false;
		/** Toast group used for non-blocking system status messages. */
		const SYSTEM_STATUS_TOAST_GROUP = 'system-status';

		/**
		 * Is this the chromeless, embedded document-split view? Shapes the whole view: it hides the
		 * toolbar and the validation-table panel, uses a reduced loading path and forces the v2
		 * viewer. "embedded" alone only drops the app navbar (see App.vue) and otherwise leaves the
		 * regular validation view intact.
		 */
		const isEmbeddedDocumentSplit = embeddedUrlParam() && viewUrlParam() === 'documentSplit';

		// The root splitter has one panel less in the embedded view, so it needs its own stored
		// layout: PrimeVue's restoreState() applies the saved sizes to the panels by index, which
		// would leave the single remaining panel at the size of the regular view's first panel.
		const verticalSplitterStateKey = isEmbeddedDocumentSplit
			? 'squeeze.validation.embeddedVerticalSplitterLayout'
			: 'squeeze.validation.verticalSplitterLayout';

		/** Loading the document for the embedded view failed, so there is nothing to show. */
		const embeddedLoadFailed = ref<boolean>(false);

		// The embedded, document-scoped flow has no next document to browse to (the token only
		// authorizes the one document) and no chrome to react to a toast, so once the split is
		// done there is nothing left to show in place of the split view: signal completion here
		// instead of navigating away (see onEmptyList).
		/** The split finished in the embedded view, so there is nothing more to show. */
		const embeddedSplitDone = ref<boolean>(false);

		// The embedded document-split view forces the v2 viewer: the router guard skips
		// fetchFeatureSet()/fetchUserSettings() for a documentToken (see router/index.ts), so
		// featureSet.v2Viewer/userSettings would otherwise default to false here. The v1 viewer
		// also couldn't work anyway, since it relies on an iframe using the session cookie, which
		// doesn't exist for a token-only, embedded caller.
		const NEW_SQUEEZE_VIEWER = isEmbeddedDocumentSplit
			|| (store.state.featureSet.v2Viewer ? store.state.userSettings.viewSettings.v2Viewer : store.state.featureSet.v2Viewer);
		const useV2ValidationTable = computed(() => shouldUseV2ValidationTable(store.state.featureSet, store.state.userSettings.viewSettings.v2ValidationTable));

		/** Current mode of component */
		const mode = ref<string>("edit");

		/** Is the current mode of component readonly? */
		const isReadOnlyMode = ref<boolean>(false);

		/** Fields of document */
		const documentFields = ref<DocumentField[]>([]);

		/** All document classes */
		const allDocumentClasses = ref<DocumentClassDto[]>([]);

		/** Tables of the document */
		const tables = ref<DocumentTable[]>([]);

		/** Field groups */
		const documentClassFieldsByGroup = ref<DocumentClassFieldGroup[]>([]);

		const serverBaseUrl = (new URL(ClientManager.getInstance().getSqueezeBasePath())).origin; // TODO: What type? ref or reactive?

		/** Indicates end of request */
		const loaded = ref<boolean>(false);
		const squeezeViewerSplitterPanelReady = ref<boolean>(false);
		const validationTableMountRequested = ref<boolean>(false);
		const validationTableReady = ref<boolean>(false);
		const tableLoadingStatusText = {
			requesting: TableStatus.getValidationTableLoadingStatusText(t, "requesting"),
			preparing: TableStatus.getValidationTableLoadingStatusText(t, "preparing"),
			loadingWidths: TableStatus.getValidationTableLoadingStatusText(t, "loadingWidths"),
			ready: TableStatus.getValidationTableLoadingStatusText(t, "ready"),
		};
		const validationTableLoadingStatus = ref<string>(tableLoadingStatusText.requesting);
		const validationPending = ref<boolean>(false);
		const validationInProgress = ref<boolean>(false);
		const activeSystemStatus = ref<string>('');
		const activeSystemStatusHasLoader = ref<boolean>(false);
		/** Minimum spacing between validation loader toast appearances, so rapid validations don't show it too often. */
		const VALIDATION_LOADER_MIN_INTERVAL_MS = 2000;
		/** Timestamp of the last validation loader toast appearance (for throttling). */
		let lastValidationLoaderShownAt = 0;
		/** Pending timer for a throttled validation loader toast. */
		let validationLoaderTimeoutId: number | null = null;
		const isValidationTableLoaded = computed(() => {
			return validationTableReady.value || validationTableLoadingStatus.value === tableLoadingStatusText.ready;
		});
		const show = ref<boolean>(true);

		/** DocumentValidationRequestDto for validation purposes  */
		const validationRequest = reactive<DocumentValidationRequestDto>({fields: []});

		/** Current Viewer-Client */
		const viewerClient = ref<ViewerClient>(); // TODO: ref or reactive?

		/** Currently active field */
		const activeDocumentField = reactive<DocumentField>({});

		/** Currently active table cell */
		const activeTableCell = ref<DocumentTableCell>({});

		/** Currently active table row index */
		const activeTableRowIndex = ref<number|null>(null);

		/** Is table in readonly mode */
		const tableInteractionReadOnly = computed(() => isReadOnlyMode.value);

		/** Indicates to block UI components specified */
		const blocked = reactive<any>({
			buttons: {
				save: false,
				suspend: false,
				delete: false,
				extract: false,
				changeDocumentClass: false,
				split: false,
				sendMail: false,
				training: false,
				testing: false,
				attachment: false,
				menu: false,
				checkDocument: false,
			},
		});

		/** Currently active table-id */
		const activeTableId = ref<number|null>(null);

		/** Currently active table */
		const activeTable = ref<DocumentTable|null>(null);

		/** Currently active Batch Class ID */
		const batchClassId = ref<number>(0);

		/** Currently active Document-Class */
		const newDocumentClass = ref<number>(0);

		/** Should the table buttons be hidden? */
		const hideTableButtons = ref<boolean>(false);

		/** Confirm dialog configuration - no options = no dropdown in dialog */
		const dialogs = reactive<any>({
			deleteDocument: {
				display: false,
				options: [{label: "", value: ""}],
				locales: {
					header: "Squeeze.Validation.Dialogs.DeleteDocument.Header",
					notice: {
						selectReason: "Squeeze.Validation.Dialogs.DeleteDocument.Notice.SelectReason",
						comment: "Squeeze.Validation.Dialogs.DeleteDocument.Notice.Comment",
					},
					selectPlaceholder: "Squeeze.Validation.Dialogs.DeleteDocument.SelectPlaceholder",
					buttons: {
						confirm: "Squeeze.Validation.Buttons.Delete",
						abort: "Squeeze.Validation.Buttons.Abort",
					},
				},
			},
			suspendDocument: {
				display: false,
				options: [],
				locales: {
					header: "Squeeze.Validation.Dialogs.SuspendDocument.Header",
					notice: {
						selectReason: "Squeeze.Validation.Dialogs.SuspendDocument.Notice.SelectReason",
						comment: "Squeeze.Validation.Dialogs.SuspendDocument.Notice.Comment",
					},
					selectPlaceholder: "Squeeze.Validation.Dialogs.SuspendDocument.SelectPlaceholder",
					buttons: {
						confirm: "Squeeze.Validation.Buttons.Suspend",
						abort: "Squeeze.Validation.Buttons.Abort",
					},
				},
			},
			lockedDocument: {
				display: false,
				locked: false,
			},
			changeDocumentClass: {
				display: false,
				loading: false,
				trainDocument: true,
				classificationClasses: [] as BatchClassClassification[],
			},
			sendMail: {
				display: false,
			},
			errorDocument: {
				display: false,
			},
		});

		/** Options of the toolbar. Due to the translations, those are defined in "mounted()" */
		const toolbarOptions = ref<any[]>([]);

		const toggleValidationTableV2 = () => {
			const userSettings = JSON.parse(JSON.stringify(store.state.userSettings));
			userSettings.viewSettings.v2ValidationTable = !userSettings.viewSettings.v2ValidationTable;
			store.commit('setUserSettings', userSettings);
			TableSettings.saveViewSettings(t, toast, store, ClientManager.getInstance().squeeze.user);
		};

		/** Single Promise for Validation Requests. Only the latest Request will be resolved */
		const singlePromiseValidation = new SinglePromise();

		/** Is the document locked by the current user? */
		const lockedByCurrentUser = ref<boolean>(false);

		/** ID of the user that is currently blocking the document **/
		const lockingUserId = ref<number|null>(null);

		/** Should the Toolbar Button Text be shown? */
		const toolbarButtonText = ref<boolean>(false);

		/** Should the Split-Document be shown? */
		const showSplitDocument = ref<boolean>(false);

		/** Hide Validation-Buttons? */
		const hideValidationButtons = ref<boolean>(false);

		/** Is the Head Training visible? */
		const showHeadTraining = ref<boolean>(false);

		/** Is the Position Training visible? */
		const showPositionTraining = ref<boolean>(false);

		/** Is the Form-based Head Training visible? */
		const showFormHeadTraining = ref<boolean>(false);

		/** Is the Form-based Position Training visible? */
		const showFormPositionTraining = ref<boolean>(false);

		/** Is the Locator test visible? */
		const showLocatorTest = ref<boolean>(false);

		/** Is the Table Splitter visible? */
		const showTableSplitter = ref<boolean>(true);

		/** Is the Table Splitter Gutter visible? */
		const showTableSplitterGutter = ref<boolean>(false);

		/** Is the OCR Results View visible? */
		const showOcrResults = ref<boolean>(false);

		/** Should the drag dialog be shown? */
		const showDragDialog = ref<boolean>(false);

		/** Time of MouseDown Event by Splitter */
		const startTimeByMouseDown = ref<number>(0);

		/** Currently active document group tab */
		const activeGroupTab = ref<number>(0);

		/** List with document fields for training */
		const trainingValues = reactive<FieldTraining>({
			id: 0,
			fieldId: 0,
			documentClassId: 0,
			trainingKeyValue: "",
			keyWordPattern: "",
			valuePattern: "",
			valueRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			keyWordRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			valueIgnoreWhitespace: false,
		});

		const trainingKeyField = ref<DocumentField|null>(null);

		/** Currently active table-field in training */
		const activeFieldTraining = ref<string>('');

		const positionTrainingValues = reactive<TableColumnTraining>({
			id: 0,
			documentClassId: 0,
			tableId: 0,
			columnId: 0,
			trainingKeyValue: "",
			columnRegion: {
				"page": 0,
				"x0": 0,
				"y0": 0,
				"x1": 0,
				"y1": 0,
			},
			valuePattern: "",
		});

		/** Currently active table-field in positionTraining */
		const activePositionTraining = ref<string>('');

		/** Current indicator in form position training */
		const indicatorOfFormTraining = reactive<FormTrainingItemRegionAnchor>({
			id: undefined,
			tableId: undefined,
			description: '',
			keyWordPattern: '',
			keyWordRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			ignoreWhiteSpaces: false,
		});

		/** Currently head field of region in form head training */
		const headFieldOfRegionInFormTraining = reactive<FormTrainingHeadField>({
			id: 0,
			fieldId: 0,
			valuePattern: '',
			valueRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			valueIgnoreWhitespace: false,
			accumulateFoundValues: false,
		});

		/** Currently item field of region in form position training */
		const itemFieldOfRegionInFormTraining = reactive<FormTrainingItemField>({
			id: 0,
			columnId: 0,
			valuePattern: '',
			valueRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			valueIgnoreWhitespace: false,
			accumulateFoundValues: false,
		});

		/** Currently region anchor object of form-based training */
		const regionAnchorOfFormTraining = reactive<FormTrainingRegionAnchor>({
			id: undefined,
			description: '',
			keyWordPattern: '',
			keyWordRegion: {
				page: 0,
				x0: 0,
				y0: 0,
				x1: 0,
				y1: 0,
			},
			ignoreWhiteSpaces: true,
		});

		/** Is the document read-only? */
		const readonly = ref<boolean>(false);

		/** Resize observe of left splitter panel */
		const resizeObserver = ref<any>(null);

		/** Current Search-Elements, used for pagination */
		const searchElements = ref<Document[]|null>(null);

		/** Viewer marked regions (V2) */
		const viewerMarkedRegions = ref<BoundingBox[]>([]);

		const viewerShouldObserveResizing = ref<boolean>(false);

		/** Is Kosit validation report file visible in viewer? */
		const showKositValidationReportFile = ref<boolean>(false);

		/** Array with all headRefFieldElements */
		const headRefFieldElements = ref<any[]>([]);

		/** Array with all tableRefElements */
		const allTableRefElements = ref<any[]>([]);

		/** Is hotKey-List visible? */
		const showHotKeyList = ref<boolean>(false);

		/** Is Log visible? */
		const showLog = ref<boolean>(false);

		/** Is attachment upload visible? */
		const showUpload = ref<boolean>(false);

		/** Message that shows the number of the currently uploaded documents  */
		const uploadLabel = ref<string>("");

		/** List of all files to be uploaded */
		const files = ref<any[]>([{
			uploadFinished: false,
			loading: false,
			errorText: '',
			error: false,
		}]);

		/** Current Progress of upload */
		const progress = ref<number>(0);

		/** Array with all error messages of fields  */
		const allErrorMessages = reactive<ErrorFields>({
			fields: [],
			lengthOfAllErrors: 0,
		});

		/** Contains the field that the error messages should be currently shown of */
		const currentErrorField = ref<DocumentField|null>(null);

		/** Name of the last  route */
		const lastRoute = ref<any>("");
		const blockBrowseButtons = ref<boolean>(false);
		const exportInProgress = ref<boolean>(false);

		/** Should the Export Error Message be shown? */
		const showExportError = ref<boolean>(false);
		const exportErrorMessage = ref<string>("");

		/** Field Layout Details */
		const fieldLayoutDetails = ref<FieldGroupDetails[]>([]);
		const fieldLayoutRowsByGroup = ref<Record<number, GridStackFieldDetails[][]>>({});

		/** All custom actions */
		const customActions = ref<CustomValidationActionDto[]>([]);

		/** All table custom actions */
		const customTableActions = ref<CustomValidationActionDto[]>([]);

		/** Is confirm dialog for execute an action shown? */
		const showCustomActionDialog = ref<boolean>(false);

		/** Custom Action dialog message */
		const customActionDialogMessage = ref<string>('');

		/** Contains the full current document */
		const currentDocument = ref<Document|null>(null);

		/** Has the validation been triggered once and has the table splitter been set? */
		const tableSplitterSetAfterValidation = ref<boolean>(false);

		/** Current Search request for document search filtering when search request is empty */
		const currentSearchRequest = reactive<DocumentSearchRequestDto>({});

		/** Current workflow context of document */
		const documentWorkflowContext = reactive<any>({});

		/** Document API endpoint */
		const documentApi = ClientManager.getInstance().squeeze.document;

		/** Document Class API endpoint */
		const documentClassApi = ClientManager.getInstance().squeeze.documentClass;

		/** Validation API endpoint */
		const validationApi = ClientManager.getInstance().squeeze.validation;

		/** Batch-Class API endpoint */
		const batchClassApi = ClientManager.getInstance().squeeze.batchClass;

		/** Bearer token and bearer interval for oAuth authentication */
		const bearerToken = ref<string|null>(null);
		const bearerInterval = ref<number|null>(null);

		if (ClientManager.getInstance().login.activeAuth === AuthTypes.Bearer) {
			bearerToken.value = ClientManager.getInstance().keycloakOptions.token;

			/** Get the current bearer-token from the keycloak-options every 30 seconds. This is done,
			 * because the ClientManager.getInstance().keycloakOptions.token is not watchable and, therefore,
			 * changes of the token are not recognized by the component.
			 * The token is used in the function "getUserAuth"
			 */
			bearerInterval.value = setInterval(() => {
				bearerToken.value = ClientManager.getInstance().keycloakOptions.token;
			}, 30000)
		}

		/** Content of the left splitter panel */
		const leftSplitterPanelContent = ref<any>();

		/** The left splitter panel component */
		const leftSplitterPanel = ref<any>();

		/** Width of the left splitter panel in Pixel */
		const leftSplitterPanelWidth = ref<number>(0);

		/** Component of the squeeze viewer (v2) */
		const SqueezeViewer = ref<any>();

		/**  Component of the validation field set */
		const validationFieldSet = ref<any>({});

		/** Component of the squeeze viewer (v1) */
		const viewer = ref<any>();

		/** Checks whether the currently active viewer panel is already mounted in the DOM. */
		const isViewerPanelMounted = () => {
			if (!squeezeViewerSplitterPanelReady.value) {
				return false;
			}

			if (NEW_SQUEEZE_VIEWER) {
				return Boolean(SqueezeViewer.value?.$el);
			}

			return Boolean(viewer.value);
		};

		/** Component of the (tiered) menu */
		const menu = ref<any>();

		/** Component of op badge */
		const opBadge = ref<any>();

		/** Component of validation table */
		const tableInValidation = ref<any>({});

		/** Reset all selected rows in current position table */
		const resetSelectedRows = ref<boolean>(false);

		/** Is automatic document validation by field changes active? */
		const autoDocumentValidation = ref<boolean>(true);

		/** Object with all validation validate-button settings */
		const validationValidateButtonSettings = computed(() => ({
			buttonName: ButtonNameEnum.Validate,
			description: t('Squeeze.Validation.Buttons.Validate'),
			color: 'background-color: var(--success-color)',
			icon: 'mdi mdi-check',
		}));

		/** Object with all validation suspend-button settings */
		const validationSuspendButtonSettings = computed(() => ({
			buttonName: ButtonNameEnum.Suspend,
			description: t('Squeeze.Validation.Buttons.Suspend'),
			color: 'background-color: var(--dex-primary-color)',
			icon: 'mdi mdi-pause',
		}));

		/** Object with all validation delete-button settings */
		const validationDeleteButtonSettings = computed(() => ({
			buttonName: ButtonNameEnum.Delete,
			description: t('Squeeze.Validation.Buttons.Delete'),
			color: 'background-color: var(--error-color)',
			icon: 'mdi mdi-delete-outline',
		}));

		const documentTypeEnum = computed(() => {
			return DocumentTypeEnum;
		});

		const findTableIndex = computed(() => {
			const tableIndex = tables.value.findIndex((table: DocumentTable) => table.id === activeTableId.value);
			if(tableIndex == -1) {
				return null;
			}
			return tables.value[tableIndex];
		});

		const disableBrowseButtons = computed(() => {
			return loaded.value != true;
		});

		const docBaseUrl = computed(() => {
			return `${ClientManager.getInstance().getSqueezeBasePath()}/documents/${props.documentId}`;
		});

		const viewerDrawingMode = computed(() => {
			return activePositionTraining.value === 'columnRegion' ? 'column' : 'rect';
		});

		const viewerSettingsForViewer = computed(() => {
			return JSON.parse(JSON.stringify(store.state.userSettings.viewSettings.viewerSettings));
		});

		/** Alert messages shown in the viewer. */
		const viewerAlertMessages = ref<BannerDto[]>([]);

		/**
		 * TEMPORARY: The backend always includes the ZUGFeRD strict mode banner
		 * (id "zugferd-strict-mode-activated"). It is a nudge to configure the setting and is
		 * only shown when: the document is a ZUGFeRD document, the "ZUGFeRDstrictMode" setting
		 * is NOT explicitly configured (neither 'true' nor 'false') on the document class nor the
		 * batch class, and the user has not dismissed it within the last 12 hours.
		 * Remove once the backend handles this by itself.
		 */
		const ZUGFERD_STRICT_MODE_BANNER_ID = 'zugferd-strict-mode-activated';
		const ZUGFERD_STRICT_MODE_SETTING = 'ZUGFeRDstrictMode';
		const ZUGFERD_STRICT_MODE_IGNORE_KEY = 'squeeze.validation.zugferdStrictMode.ignoreAlert';

		/** Loads the viewer banner messages for the current document class. */
		const loadViewerAlertMessages = async () => {
			const banners = await loadBannerMessages(props.documentClassId);

			// TEMPORARY: the ZUGFeRD strict mode banner may only be shown for ZUGFeRD documents
			// and when documentclass has strict mode active. Hide it otherwise.
			const hasZugferdBanner = banners.some(banner => banner.id === ZUGFERD_STRICT_MODE_BANNER_ID);
			if (hasZugferdBanner) {
				const isZugferdDocument = currentDocument.value?.documentType === documentTypeEnum.value.Zugferd;
				const showZugferdBanner = isZugferdDocument
					&& !isAlertDismissed(ZUGFERD_STRICT_MODE_IGNORE_KEY)
					&& (await resolveClassSetting(ZUGFERD_STRICT_MODE_SETTING, props.documentClassId, batchClassId.value)) === null;
				if (!showZugferdBanner) {
					viewerAlertMessages.value = banners.filter(banner => banner.id !== ZUGFERD_STRICT_MODE_BANNER_ID);
					return;
				}
			}

			viewerAlertMessages.value = banners;
		};

		/**
		 * Handles clicks on links embedded in viewer alert messages. App-internal
		 * paths (starting with "/") are navigated via the router (SPA, no reload);
		 * absolute/external URLs keep their default anchor behavior.
		 */
		const onViewerClickAlertLink = (payload: {link: LinkDto; event: MouseEvent}) => {
			const href = payload?.link?.href;
			const isInternal = !!href && href.startsWith('/') && !href.startsWith('//');
			const opensNewTab = payload?.link?.target === '_blank';

			if (isInternal && !opensNewTab) {
				payload.event?.preventDefault();
				router.push(href!);
			}
		};

		/**
		 * Triggered when a viewer banner is closed
		 */
		const onViewerCloseAlertMessage = (payload: {banner: BannerDto; index: number}) => {
			if (payload?.banner?.id === ZUGFERD_STRICT_MODE_BANNER_ID) {
				dismissAlert(ZUGFERD_STRICT_MODE_IGNORE_KEY);
			}
		};

		/** Triggered when hover on button to show the document type
		 * @param documentType
		 */
		const onHoverDocumentType = (documentType: string) => {
			if (documentType === 'xrechnung') {
				return t('Squeeze.DocumentClasses.DocumentTypeXRechnung');
			}

			if (documentType === 'zugferd') {
				return t('Squeeze.DocumentClasses.DocumentTypeZUGFeRD');
			}
		}

		/**
		 * Returns the background color of the document type button
		 * @param documentStatus
		 */
		const btnDocumentTypeBackgroundColor = (documentStatus: string) => {
			if (documentStatus === 'invalid') {
				return 'background-color: var(--error-color);';
			} else if (documentStatus === 'warning') {
				return 'background-color: var(--warning-color);';
			} else if (documentStatus === 'valid') {
				return 'background-color: var(--success-color);';
			}
			return 'background-color: #a9a9a9;';
		}

		/**
		 * Checks the severity of a message for the status of a document with the type of xrechnung or zugferd
		 * @param isMessageBtn Is this a severity check on a button (in a message) ?
		 */
		const checkSeverityForStatusMessage = (isMessageBtn: boolean = false) => {
			if (currentDocument.value!.xmlValidationState === XmlValidationStateEnum.Warning) {
				return isMessageBtn ? "warning" : "warn";
			}

			return isMessageBtn ? "danger" : "error";
		}

		/** Checks the severity of a message */
		const checkErrorSeverity = () => {
			if (!currentErrorField.value) {
				if (allErrorMessages.lengthOfAllErrors === 0) {
					return "success";
				}
			}

			if (allErrorMessages && currentErrorField.value && currentErrorField.value.value!.state?.toLowerCase() === 'forceapproval') {
				return "info"
			}

			if (allErrorMessages && currentErrorField.value && currentErrorField.value.value!.state?.toLowerCase() === 'ok') {
				return "success"
			}

			return "error";
		}

		/**
		 * Toggle error messages
		 * @param event
		 */
		const toggleErrorMessages = (event: any) => {
			const overlayPanel: any = opBadge.value;
			overlayPanel.toggle(event);
		}

		/**
		 * Unlocks the current document
		 * @param ignoreError If true no error will be displayed if unlocking fails
		 */
		const unlockDocument = async (ignoreError = false) => {
			// Only unlock locked documents if it's locked by the current user
			if (!dialogs.lockedDocument.locked && lockedByCurrentUser.value) {
				try {
					await documentApi.unlockDocument(props.documentId);
				} catch (err: unknown) {
					if (!ignoreError) {
						ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err);
					}
				}
			}
		}

		/** Reset document-specific lock and interaction state before loading another document. */
		const resetDocumentInteractionState = () => {
			mode.value = 'edit';
			readonly.value = false;
			isReadOnlyMode.value = false;
			hideTableButtons.value = false;
			lockedByCurrentUser.value = false;
			lockingUserId.value = null;
			dialogs.lockedDocument.locked = false;
			blocked.buttons.training = false;
			blocked.buttons.testing = false;
			blocked.buttons.attachment = false;
		}

		/** Go back to queue list */
		const goBackToQueueList = () => {
			router.push({
				name: 'QueueEntryView',
				params: { stepName: route.query.target as any},
				query: {
					page: route.query.page as any,
					filters: route.query.filters as any,
					tableSort: route.query.tableSort as any,
				},
			});
		}

		/** Change the View to the Overview */
		const goBackToValidationList = () => {
			// if the component was opened from the QueueEntryView, go back there
			if (route.query.parent && route.query.parent === 'QueueList' && route.query.target) {
				goBackToQueueList();
				return;
			}

			let routeName = "DocumentListValidation";
			const currentSearch = props.searchRequest;
			if (Object.keys(props.searchRequest).length === 0 && Object.keys(currentSearchRequest).length > 0) {
				Object.assign(currentSearch, currentSearchRequest);
			}

			// set default search when validation open via link
			if (Object.keys(currentSearch).length === 0 && documentWorkflowContext.step && documentWorkflowContext.step.toLowerCase() === 'validation') {
				currentSearch.workflowContextFilters = [
					{
						fieldName: "queueStep",
						comp: "eq",
						searchValue: "validation",
						fieldType: "text",
					},
				]
			} else if (Object.keys(currentSearch).length === 0) {
				// When there is no search and the step is not validation, go to DocumentList
				routeName = "DocumentList";
			}

			// If there is a filter and one of the filters is from validation, go to DocumentListValidationWithSearch, otherwise go to DocumentList
			if (Object.keys(currentSearch).length > 0) {
				if (currentSearch.workflowContextFilters?.find(filter => filter.searchValue === "validation" && filter.fieldName === "queueStep")) {
					routeName = "DocumentListValidationWithSearch";
				} else {
					routeName = "DocumentList";
				}
			}

			router.replace({name: routeName, params: {
				documentClassId: route.params.documentClassId,
				searchRequest: JSON.stringify(currentSearch),
				tableSortStart: JSON.stringify(props.tableSortStart),
				pagination: JSON.stringify(props.pagination),
			}});
		}

		/**
		 * Navigates to another document.
		 * Tries to unlock the current document before starting the navigation.
		 */
		const gotoDocument = (id: number, replace: boolean = true) => {
			// Reload data uses the documentId and documentClassId props which are bound to route params
			// When this watcher is called, those props do NOT yet contain the values of the `to` route params.
			// Therefore the data is reloaded on the next tick.
			// Before that happens, unlock the document we are leaving
			if (lockedByCurrentUser.value) {
				unlockDocument(true);
			}
			resetDocumentInteractionState();

			// Todo: Somehow make sure that if the next route element does not find the document (404), the fallback is the validation list
			const route: RouteLocationRaw = {
				name: "ValidateEntry",
				params: {
					documentClassId: props.documentClassId,
					documentId: id,
					searchRequest: JSON.stringify(props.searchRequest),
					pagination: JSON.stringify(props.pagination),
					tableSortStart: JSON.stringify(props.tableSortStart),
				},
			};

			// Reset Training-Marks
			viewerMarkedRegions.value = [];
			router.push(route);
		}

		/** Browses to the previous document */
		const browseLeft = async () => {
			try {
				const prevDocument = await validationApi.browseValidation(props.documentId, props.documentClassId, "previous", props.searchRequest, props.tableSortStart);

				if (!prevDocument) {
					goBackToValidationList();
					return;
				}

				gotoDocument(prevDocument);
			} catch(response) {
				// Check if response is json, show generic error if not
				if (response.json != null) {
					ToastManager.showError(toast, t('Squeeze.General.Error'), String(response.statusText));
					return;
				}

				const completeResponse = await response.json() as ErrorDto;
				ToastManager.showError(toast, t('Squeeze.General.Error'), String(completeResponse.message));
			}
		}

		/**
		 * Go to next document
		 * @param getNextToValidate
		 */
		const goToNextDocument = async (getNextToValidate: boolean|undefined = undefined) => {
			try {
				const nextDocument = await validationApi.browseValidation(props.documentId, props.documentClassId, "next", props.searchRequest, props.tableSortStart, getNextToValidate);

				if (!nextDocument) {
					//props.pagination.page = 0; //TODO: Check if we need this?!
					goBackToValidationList();
					return;
				}

				dialogs.lockedDocument.display = false;
				gotoDocument(Number(nextDocument));
			} catch(response) {
				// Check if response is json, show generic error if not
				if (response.json != null) {
					ToastManager.showError(toast, t('Squeeze.General.Error'), String(response.statusText));
					return;
				}

				const completeResponse = await response.json() as ErrorDto;
				ToastManager.showError(toast, t('Squeeze.General.Error'), String(completeResponse.message));
			}
		}

		/** Reopens the Validation show (Shows the Buttons, tables and fields, hides everything else) */
		const reopenValidationView = () => {
			showSplitDocument.value = false;
			hideTableButtons.value = false;
			hideValidationButtons.value = false;
			showHeadTraining.value = false;
			showPositionTraining.value = false;
			showFormHeadTraining.value = false;
			showFormPositionTraining.value = false;
			showLocatorTest.value = false;
			loaded.value = true;
			showTableSplitter.value = true;
			showOcrResults.value = false;

			// reset markedRegions in viewer
			viewerMarkedRegions.value = [];
		}

		/** Disable viewer on resizing */
		const disableViewerOnResizing = () => {
			viewerShouldObserveResizing.value = false;

			if (!isViewerPanelMounted()) {
				return;
			}

			// Set Pointer Event on Viewer to none, when resize start
			if (NEW_SQUEEZE_VIEWER) {
				SqueezeViewer.value.$el.style.pointerEvents = 'none';
			} else {
				viewer.value.style.pointerEvents = 'none';
			}
		}

		/** Enable viewer after resizing */
		const enableViewerAfterResizing = () => {
			viewerShouldObserveResizing.value = true;

			if (!isViewerPanelMounted()) {
				return;
			}

			// Set Pointer Event on Viewer to auto, when resize end
			if (NEW_SQUEEZE_VIEWER) {
				SqueezeViewer.value.$el.style.pointerEvents = 'auto';
			} else {
				viewer.value.style.pointerEvents = 'auto';
			}
		}

		/**
		 * Triggered on Splitter mouse down
		 * @param event
		 */
		const onSplitterMouseDown = (event: MouseEvent) => {
			// Only run if splitter-gutter was clicked!
			const target = event.target as HTMLElement;
			if (!target.matches('.p-splitter-gutter, .p-splitter-gutter *')) {
				return;
			}

			// Set startTime of MouseDown
			startTimeByMouseDown.value = event.timeStamp;

			disableViewerOnResizing();
		}

		/** Set Table Splitter to disabled or enabled */
		const toggleSplitterTable = () => {
			showTableSplitter.value = !showTableSplitter.value;
		}

		/**
		 * Triggered on Splitter mouse up
		 * @param event
		 */
		const onSplitterMouseUp = (event: MouseEvent) => {
			// Only run if splitter-gutter was clicked!
			const target = event.target as HTMLElement;
			if (!target.matches('.p-splitter-gutter, .p-splitter-gutter *')) {
				return;
			}

			// Get Time difference between MouseDown and MouseUp Event
			const timeBetweenMouseDownAndUp = (event.timeStamp - startTimeByMouseDown.value);
			if (!showHeadTraining.value && !showPositionTraining.value && !showFormHeadTraining.value && !showFormPositionTraining.value && !showSplitDocument.value && !showOcrResults.value && !showLocatorTest.value) {
				if (target.matches('.p-splitter-panel-nested .p-splitter-gutter-handle')) {
					// horizontal splitter gutter handle &ndash;&gt; do nothing by click
					enableViewerAfterResizing();
					return;
				} else if (target.matches('.p-splitter-gutter-handle')) {
					// Get Time difference between MouseDown and MouseUp Event
					if (timeBetweenMouseDownAndUp <= 150) {
						toggleSplitterTable();
					}
				}
			}

			enableViewerAfterResizing();
		}

		/** Triggered on splitter resize end */
		const onSplitterResizeEnd = () => {
			leftSplitterPanelWidth.value = leftSplitterPanel.value.$el.clientWidth;
			enableViewerAfterResizing();
		}

		/**
		 * Is triggered when files are selected from the Component
		 * @param event File-Select event
		 */
		const onSelectFiles = (event: any) => {
			files.value = event.files;
			uploadLabel.value = t("Squeeze.General.Upload") + " (" + files.value.filter(file => file.uploadFinished).length + "/" + files.value.length + ")";
		}

		/**
		 * Is triggered when the "clear" button is pressed in the Upload-Component
		 * @param event
		 */
		const clearFiles = (event: any) => {
			uploadLabel.value = t("Squeeze.General.Upload");
		}

		/**
		 * Is triggered when a single file is removed from upload
		 * @param event
		 */
		const removeFile = (event: any) => {
			files.value = event.files;
			uploadLabel.value = t("Squeeze.General.Upload") + " (" + files.value.filter(file => file.uploadFinished).length + "/" + files.value.length + ")";
		}

		/**
		 * Manual file upload to the Squeeze API. This has been programmed because the generated API client does not
		 * support multipart/form-data requests: https://github.com/swagger-api/swagger-codegen/issues/3921
		 * @param file
		 * @returns Object with the id of the created document
		 */
		const manualFileUpload = async (file: File) => {
			// Todo: Once the generated client works, make this function deprecated and use the client function:
			const body = new FormData();
			body.set("file", file);

			const response = await ClientManager.getInstance().customFetch(ClientManager.getInstance().getSqueezeBasePath() + "/documents/" + props.documentId + "/attachments", {
				method: "POST",
				body: body,
			});

			if (response.status !== 204) {
				const responseJSON = await response.json();
				throw new Error(responseJSON.message);
			}

			return true;
		}

		/**
		 * Uploads the files from the file-uploader
		 * @param event
		 */
		const fileUploader = (event: any) => {
			files.value = event.files;

			progress.value = 0;
			// Calculate progress
			uploadLabel.value = t("Squeeze.General.Upload") + " (" + files.value.filter(file => file.uploadFinished).length + "/" + files.value.length + ")";

			// TODO: Limit the amount of uploads running in parallel (?)
			event.files
				.forEach((file: any, index: number) => {
					if (!file.uploadFinished) { // Files that are already finished shouldn't be uploaded again
						const idx = index;
						files.value[idx].error = false;
						files.value[idx].errorText = "";
						files.value[idx].loading = true;
						files.value = [...files.value];

						manualFileUpload(file)
							.then(() => {
								files.value[idx].uploadFinished = true;
							})
							.catch(err => {
								files.value[idx].error = true;
								files.value[idx].errorText = err.message;
							})
							.finally(() => {
								files.value[idx].loading = false;
								files.value = [...files.value];

								// Calculate progress
								const finished = files.value.filter(file => file.uploadFinished);
								progress.value = Math.round((finished.length * 100) / files.value.length);
								uploadLabel.value = t("Squeeze.General.Upload") + " (" + finished.length + "/" + files.value.length + ")";

								if (NEW_SQUEEZE_VIEWER) {
									SqueezeViewer.value.refreshAttachments();
								} else {
									// Reload iFrame to reload attachments in old viewer
									const iFrame = document.getElementById('SqueezeViewer') as any;
									if (iFrame instanceof HTMLIFrameElement && iFrame.contentWindow != null) {
										// get viewer url for reload
										const viewer = ClientManager.getInstance().viewer;
										const viewerUrl: string = viewer.basePath + '/Viewer.php?aktion=showQueueEntryDetails&sourceSystem=documents&xdocid=' + props.documentId;
										iFrame.contentWindow.location.replace(viewerUrl);
									}
								}
							});
					}
				})
		}

		/** Triggered on drag enter */
		const onDragEnter = () => {
			showDragDialog.value = true;
		}

		/** Triggered on drag leave */
		const onDragLeave = () => {
			showDragDialog.value = false;
		}

		/**
		 * Triggered on drop
		 * @param event
		 */
		const onDrop = (event: any) => {
			event.stopPropagation();
			event.preventDefault();
			showDragDialog.value = false;

			const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
			showUpload.value = true;
			nextTick(() => {
				const uploadFiles: any[] = [];
				for (const file of files) {
					file.uploadFinished = false;
					file.error = false;
					file.errorText = "";
					file.loading = false;
					uploadFiles.push(file);
				}
				files.value = uploadFiles;
				fileUploader({files: uploadFiles});
			})
		}

		/**
		 * Triggered when a Table Cell is focused
		 * @param fieldName
		 */
		const onFocusFieldTraining = (fieldName: string) => {
			activeFieldTraining.value = fieldName;
		}

		/**
		 * Triggered when the position training values are reset
		 * @param values
		 */
		const onChangePositionTrainingValues = (values: TableColumnTraining) => {
			Object.assign(positionTrainingValues, values);
		}

		/**
		 * Triggered when a field of position training is focused
		 * @param fieldName
		 */
		const onFocusFieldOfPositionTraining = (fieldName: string) => {
			activePositionTraining.value = fieldName;
			if (activePositionTraining.value === 'columnRegion') {
				viewerClient.value?.activateColumnMarking();
			} else {
				viewerClient.value?.deactivateColumnMarking();
			}
		}

		/**
		 * Triggered when a Table Cell is focused
		 * @param markRegions
		 */
		const onMarkRegion = (markRegions: any) => {
			if (Array.isArray(markRegions)) {
				viewerMarkedRegions.value = markRegions as BoundingBox[];
				viewerClient.value?.markRegions(markRegions);
			} else {
				// This is a special case for the position training
				markRegions.page = 0;
				viewerMarkedRegions.value = [markRegions] as BoundingBox[];
				viewerClient.value?.markRegion(markRegions);
			}
		}

		/**
		 * Triggered when a Table Row is clicked
		 * @param markLine
		 */
		const onMarkLines = (markLine: any) => {
			viewerMarkedRegions.value = [markLine.data.boundingBox];
			viewerClient.value?.markRegion(markLine.data.boundingBox);
		}

		/**
		 * Triggered when a Table Cell is clicked
		 * @param markWord
		 */
		const onMarkWord = (markWord: any) => {
			viewerMarkedRegions.value = [markWord.data.boundingBox];
			viewerClient.value?.markRegion(markWord.data.boundingBox);
		}

		/**
		 * Triggered when a page on the Document Split Component is clicked
		 * @param page Page that is triggered
		 */
		const onSplitImageClick = (page: number) => {
			// reset markedRegions in viewer
			viewerMarkedRegions.value = [];

			if (NEW_SQUEEZE_VIEWER) {
				viewerMarkedRegions.value = [{page: page, x0: 1, x1: 1, y0: 1, y1: 1}];
			} else {
				viewerClient.value?.goToPage(page);
			}
		}

		/**
		 * Triggered when pages were split off but the document still has pages left (see
		 * DocumentSplit's onPagesSplit). The viewer only fetches the document once on mount, so
		 * without this it would keep showing the already-split-off pages.
		 */
		const onPagesSplit = async () => {
			currentDocument.value = await documentApi.getDocumentById(props.documentId);

			if (NEW_SQUEEZE_VIEWER) {
				SqueezeViewer.value.refreshAttachments();
			} else {
				// Reload iFrame to reload pages in old viewer
				const iFrame = document.getElementById('SqueezeViewer') as any;
				if (iFrame instanceof HTMLIFrameElement && iFrame.contentWindow != null) {
					const viewer = ClientManager.getInstance().viewer;
					const viewerUrl: string = viewer.basePath + '/Viewer.php?aktion=showQueueEntryDetails&sourceSystem=documents&xdocid=' + props.documentId;
					iFrame.contentWindow.location.replace(viewerUrl);
				}
			}
		}

		/**
		 * Browses to the next document
		 * @param getNextToValidate
		 */
		const getNextDocument = async (getNextToValidate: boolean|undefined = undefined) => {
			try {
				const nextDocument = await validationApi.browseValidation(props.documentId, props.documentClassId, "next", props.searchRequest, props.tableSortStart, getNextToValidate);
				if (!nextDocument) {
					return;
				}
				return (Number(nextDocument))
			} catch(response) {
				// Check if response is json, show generic error if not
				if (response.json != null) {
					ToastManager.showError(toast, t('Squeeze.General.Error'), String(response.statusText));
					return;
				}

				const completeResponse = await response.json() as ErrorDto;
				ToastManager.showError(toast, t('Squeeze.General.Error'), String(completeResponse.message));
			}
		}

		/**
		 * This function handles the nextDocument id that is returned by {@link getNextDocument}. If next document id is
		 * undefined this functions routes the user back to validation list, otherwise to the next document.
		 * @param nextDocumentId
		 */
		const handleNextDocumentId = (nextDocumentId: number | undefined) => {
			if (nextDocumentId) {
				// check if the split document view is shown, so that deactivate view of the split document
				if (showSplitDocument.value) {
					hideValidationButtons.value = false;
					showSplitDocument.value = false;
				}
				gotoDocument(nextDocumentId);
			} else {
				//props.pagination.page = 0; //TODO: Check if we need this?!
				goBackToValidationList();
				return;
			}
		}

		/** Is triggered when there are no more pages to split */
		const onEmptyList = async () => {
			// A document-scoped token does not authorize browseValidation (list-browsing) or the
			// validation-list/queue routes handleNextDocumentId navigates to, and there is no next
			// document to browse to anyway in a single-document embedded session. Skip both and show
			// a persistent, in-place message instead, since there is no chrome here for the user to
			// notice the transient toast the regular flow relies on (same rationale as
			// embeddedLoadFailed).
			if (isEmbeddedDocumentSplit) {
				documentApi.deleteDocumentById(props.documentId, "SplitDone")
					.then(() => {
						embeddedSplitDone.value = true;
					})
					.catch(response => response.json().then ((err: { message: string }) => {
						ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
					}))
				return;
			}

			const nextDocumentId = await getNextDocument(true);
			documentApi.deleteDocumentById(props.documentId, "SplitDone")
				.then(() => {
					ToastManager.showSuccess(toast, t('Squeeze.General.Success'), t('Squeeze.Validation.Dialogs.SplitDocument.AllPagesSplit'));
					handleNextDocumentId(nextDocumentId);
				})
				.catch(response => response.json().then ((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
		}

		/**
		 * Triggered when a Head Field is focused
		 * @param field
		 */
		const markFieldByRegion = (field: DocumentField) => {
			currentErrorField.value = field;
			activeTableCell.value.columnId = 0;  // invalidate active Table-Cell field
			Object.assign(activeDocumentField, field);

			if (field.value && field.value.boundingBox) {
				viewerMarkedRegions.value = [field.value.boundingBox];
			}
			if (field.value && field.value.boundingBox && viewerClient.value) {
				viewerClient.value.markRegion(field.value.boundingBox);
			}
		}

		/**
		 * Formats an amount to locale string (Formats are only defined in the backend)
		 * @param value
		 */
		const formatAmount = (value: string) => {
			return value;
			/*value = value.replace(/[^0-9.,-]/g, "");

			if(value.indexOf(",") != -1) {
				value = value.replaceAll(".", "").replace(",", ".");
			}

			if(value.length > 0) {
				return parseFloat(value).toLocaleString(i18n.global.locale.value.toLowerCase() + '-' + i18n.global.locale.value.toUpperCase(), {minimumFractionDigits: 2});
			} else {
				return "0,00";
			}*/
		}

		/** Build validation request */
		const buildValidationRequest = () => {
			Object.assign(validationRequest, {
				xdocId: props.documentId,
				fields: [],
				tables: tables.value,
			});

			/**
			 * FIXME: Refactor ValidateFieldDto as well as DocumentField to match required params.
			 * Consider a low payload by passing necessary information only:
			 * - id
			 * - value
			 * - type
			 * Consider adding validation results for each field:
			 * - errortext
			 * - state
			 */
			documentFields.value.forEach(field => {
				let id = field.id;
				if (!id) id = 0;
				let fieldValue = field.value?.value;
				if (!fieldValue) fieldValue = "";
				if (field.dataType?.toLowerCase() === "amount") fieldValue = "" + fieldValue;
				let fieldState = field.state;
				if (!fieldState) fieldState = "";

				const validationField = {
					id: id,
					name: field.name,
					mandatory: field.mandatory,
					readonly: field.readonly,
					hidden: field.hidden,
					forceValidation: field.forceValidation,
					state: fieldState,
					errorText: "",
					value: {
						value: fieldValue,
						boundingBox: field.value?.boundingBox,
					},
				}
				validationRequest.fields?.push(validationField);
			});
		}

		/**
		 * handle validation field response
		 * @param validationFields
		 */
		const handleValidationFieldResponse = (validationFields: ValidationFieldDto[]) => {
			let isValid = true;

			validationFields.forEach((field: ValidationFieldDto)  => {
				const index = documentFields.value.findIndex((documentField) => {
					return documentField.id === field.id;
				});

				if (field.state === "ERROR" || field.state === "FORCEAPPROVAL") {
					isValid = false;
				}

				const uiField = documentFields.value[index];
				switch (uiField.dataType?.toLowerCase()) {
				case "amount":
					uiField.value!.value = formatAmount(field.value.value as any);
					break;
				default:
					uiField.value!.value = field.value.value;
					break;
				}

				uiField.value!.boundingBox = field.value.boundingBox;
				if (field.mandatory != null) uiField.mandatory = field.mandatory;
				if (field.readonly != null) uiField.readonly = field.readonly;
				if (field.hidden != null) uiField.hidden = field.hidden;
				if (field.forceValidation != null) uiField.forceValidation = field.forceValidation;

				if (field.errorCode === -1 || field.errorCode == null) {
					// Unknown error code or no error code set: use plain errorText
					uiField.value!.errorText = field.errorText;
				} else {
					uiField.value!.errorText = t("Squeeze.Validation.ErrorCode." + field.errorCode);
				}

				uiField.value!.state = field.state;
			});

			return isValid;
		}


		/**
		 * Falls das Dokument im Hintergrund-Tab liegt arbeitet requestAnimationFrame
		 * Timer verhindert dies und führt im Hintergrund weiter aus
		 */
		function waitForNextFrame(): Promise<void> {
			return new Promise<void>((resolve) => {
				// Hintergrund-Tab: Timer als Fallback
				const fallbackId = window.setTimeout(resolve, document.hidden ? 0 : 100);

				// Sichtbarer Tab
				requestAnimationFrame(() => {
					window.clearTimeout(fallbackId);
					resolve();
				});
			});
		}

		/**
		 * Make UI responsible between calculations.
		 */
		async function allowUiToRender() {
			if (!store.state.featureSet.v2ValidationTable) {
				return;
			}

			await waitForNextFrame();
		}

		/**
		 * Handle validation table response
		 * @param validationTables
		 */
		const handleValidationTableResponse = async (validationTables: DocumentTable[]) => {
			let isValidTable = true;
			let processedCells = 0;

			// validation tableRow cell state
			for (const table of validationTables) {
				for (const row of table.rows ?? []) {
					for (const cell of row.cells ?? []) {
						isValidTable = cell.state === "OK" || cell.state === "FORCEAPPROVAL";
						processedCells++;

						// die erste ungültige Zelle beendet die Prüfung sofort, um kein Durchlauf bis zum ende zu haben. Spart ressourcen
						if (!isValidTable) {
							return false;
						}

						// Every 250 line, give browser possibility to handle user interactions
						// Otherwise UI is "stuck or frozen" for user with many lines
						if (processedCells % 250 === 0) {
							await allowUiToRender();
						}
					}
				}
			}

			/* validation table states
			validationTables.forEach((table) => {
				if (!isValidTable) return false;
				isValidTable = table.state === "OK" || table.state === "FORCEAPPROVAL";
			})
			*/

			return isValidTable;
		}

		/** Get all error messages of fields */
		const getAllErrorMessages = async () => {
			const allErrorMessagesHead = documentFields.value.filter((field: DocumentField) => (field.value?.state?.toLowerCase() === 'error' || field.value?.state?.toLowerCase() === 'forceapproval'));
			const allErrorMessagesPos: DocumentField[] = [];

			for (let index = 0; index < tables.value.length; index++) {
				const table = tables.value[index];
				if (table.state?.toLowerCase() === 'error' || table.state?.toLowerCase() === 'forceapproval') {
					allErrorMessagesPos.push({
						description: getTranslatedDescription(table),
						value: {
							errorText: t('Squeeze.Validation.General.ErrorLines') + " " + table.errorText,
						},
					});
				}

				if ((index + 1) % 25 === 0) {
					await allowUiToRender();
				}
			}

			allErrorMessages.lengthOfAllErrors = allErrorMessagesHead.length + allErrorMessagesPos.length;

			// Get first error field if there is none selected
			if (!currentErrorField.value) {
				const firstErrorField = documentFields.value.find((field: DocumentField) => (field.value?.state?.toLowerCase() === 'error' || field.value?.state?.toLowerCase() === 'forceapproval'));
				if (firstErrorField) {
					currentErrorField.value = firstErrorField;
				}
			}

			allErrorMessages.fields = allErrorMessagesHead.concat(allErrorMessagesPos);
		}

		/** Checks whether the loaded document already contains validation states from the backend. */
		const hasInitialValidationState = () => {
			const hasFieldState = documentFields.value.some((field) => {
				return Boolean(field.value?.state || field.value?.errorText || field.state);
			});

			const hasTableState = tables.value.some((table) => {
				if (table.state || table.errorText) {
					return true;
				}

				return Boolean(table.rows?.some((row) => row.cells?.some((cell) => cell.state || cell.errorText)));
			});

			return hasFieldState || hasTableState;
		};

		/** Applies the loaded validation state to the UI without triggering a fresh validation request. */
		const applyLoadedValidationState = async () => {
			const hasBlockingHeadErrors = documentFields.value.some((field) => {
				const state = (field.value?.state || field.state || '').toUpperCase();
				return state === 'ERROR' || state === 'FORCEAPPROVAL';
			});
			const hasBlockingTableErrors = tables.value.some((table) => {
				const tableState = (table.state || '').toUpperCase();
				if (tableState === 'ERROR' || tableState === 'FORCEAPPROVAL') {
					return true;
				}

				return Boolean(table.rows?.some((row) => row.cells?.some((cell) => {
					const state = (cell.state || '').toUpperCase();
					return state === 'ERROR' || state === 'FORCEAPPROVAL';
				})));
			});

			await getAllErrorMessages();

			const isValid = !hasBlockingHeadErrors && !hasBlockingTableErrors;
			blocked.buttons.save = !isValid;

			return isValid;
		};

		/**
		 * Check table behaviour
		 * @param table
		 */
		const checkTableBehaviour = (table: DocumentTable) => {
			switch(table.tableBehaviour) {
			case TableBehaviourEnum.Open: {
				showTableSplitter.value = true;
				break;
			}
			case TableBehaviourEnum.Closed: {
				showTableSplitter.value = false;
				break;
			}
			default: {
				showTableSplitter.value = table.rows?.length !== 0;
				break;
			}
			}
		}

		/** Gets the Object for the currently active table */
		const getActiveTable = () => {
			const allVisibleTables = tables.value.filter(table => !table.hidden);
			const table = allVisibleTables.find(table => table.id === activeTableId.value)

			Object.assign(activeTable, undefined);
			showTableSplitterGutter.value = false;

			if (table) {
				activeTable.value = table;
				showTableSplitterGutter.value = true;
			}
		}

		/** Toggle result list */
		const toggleResultList = () => {
			disableViewerOnResizing();
			nextTick(() => {
				enableViewerAfterResizing();
			})
		}

		const updateSystemStatusToast = (status: string, showLoader = false, title?: string) => {
			if (activeSystemStatus.value === status && activeSystemStatusHasLoader.value === showLoader) {
				return;
			}

			toast.removeGroup(SYSTEM_STATUS_TOAST_GROUP);
			activeSystemStatus.value = status;
			activeSystemStatusHasLoader.value = showLoader;

			if (!status) {
				return;
			}

			const message = {
				group: SYSTEM_STATUS_TOAST_GROUP,
				summary: title ?? t('Squeeze.General.Loading'),
				detail: {
					text: status,
					showLoader,
				},
				closable: false,
			};

			toast.add(message);
		};

		const refreshSystemStatus = () => {
			// The validation table (whose loading status this reflects) never mounts in the
			// embedded document-split view, so its status would stay stuck at "requesting" forever.
			if (isEmbeddedDocumentSplit) {
				return;
			}

			if (validationPending.value || validationInProgress.value) {
				// Show the loader, but throttle new appearances so rapid validations don't show it too often.
				if (activeSystemStatus.value === t('Squeeze.Validation.General.ValidationInProgress') || validationLoaderTimeoutId !== null) {
					return; // already visible or a throttled show is already scheduled
				}
				const remaining = VALIDATION_LOADER_MIN_INTERVAL_MS - (Date.now() - lastValidationLoaderShownAt);
				if (remaining <= 0) {
					lastValidationLoaderShownAt = Date.now();
					updateSystemStatusToast(t('Squeeze.Validation.General.ValidationInProgress'), true);
				} else {
					// Too soon since the last one: show it once the interval has elapsed, if still validating.
					validationLoaderTimeoutId = window.setTimeout(() => {
						validationLoaderTimeoutId = null;
						refreshSystemStatus();
					}, remaining);
				}
				return;
			}

			// No validation running: cancel a scheduled loader.
			if (validationLoaderTimeoutId !== null) {
				window.clearTimeout(validationLoaderTimeoutId);
				validationLoaderTimeoutId = null;
			}

			if (isValidationTableLoaded.value) {
				updateSystemStatusToast('');
				return;
			}

			if (validationTableLoadingStatus.value && validationTableLoadingStatus.value !== tableLoadingStatusText.ready) {
				updateSystemStatusToast(validationTableLoadingStatus.value, true);
				return;
			}

			updateSystemStatusToast('');
		};

		watch([validationPending, validationInProgress, validationTableLoadingStatus], () => {
			refreshSystemStatus();
		}, { immediate: true });

		/** True while an editable table-cell input has focus (used to defer table re-renders during editing). */
		const isValidationTableCellFocused = (): boolean => {
			const active = document.activeElement as HTMLElement | null;
			if (!active || (active.tagName !== 'INPUT' && active.tagName !== 'TEXTAREA')) {
				return false;
			}
			if ((active as HTMLInputElement).type === 'checkbox') {
				return false;
			}
			return Boolean(active.closest('.validation-table-panel'));
		};

		/**
		 * Merges a validation response's cell values/states into the existing table cells
		 * if we overwrite the whole table with the response, we get a bug when more then >3000 positions
		 * when fast editing is not possible
		 */
		const applyTableValidationResultInPlace = (responseTables: DocumentTable[]): boolean => {
			const focusedCell = activeTableCell.value;
			const focusedRowIndex = activeTableRowIndex.value != null ? activeTableRowIndex.value - 1 : -1;

			for (const responseTable of responseTables) {
				const localTable = tables.value.find(table => table.id === responseTable.id);
				const localRows = localTable?.rows ?? [];
				const responseRows = responseTable.rows ?? [];
				if (!localTable || localRows.length !== responseRows.length) {
					return false;
				}

				localRows.forEach((localRow, rowIndex) => {
					const responseCellsByName = new Map((responseRows[rowIndex].cells ?? []).map(cell => [cell.columnName, cell]));
					(localRow.cells ?? []).forEach(localCell => {
						const isEditedCell = localCell === focusedCell
							|| (rowIndex === focusedRowIndex && localCell.columnName === focusedCell?.columnName);
						const responseCell = responseCellsByName.get(localCell.columnName);
						if (isEditedCell || !responseCell) {
							return;
						}
						localCell.value = responseCell.value;
						localCell.state = responseCell.state;
						localCell.errorText = responseCell.errorText;
						localCell.errorCode = responseCell.errorCode;
					});
				});
			}
			return true;
		};

		/**
		 * Validate document fields (trigger by field value change and at save event)
		 * @param manuellyTriggered
		 */
		const runValidateDocument = async (manuellyTriggered = false) => {
			validationPending.value = false;
			validationInProgress.value = true;
			refreshSystemStatus();
			await nextTick();
			await allowUiToRender();
			// manuellyTriggered is true if the validation was triggered by the user - triggered from the checkDocument button
			if (!autoDocumentValidation.value && !manuellyTriggered) {
				validationInProgress.value = false;
				refreshSystemStatus();
				return false;
			}

			let isValidHead = true;
			let isValidTable = true;
			blocked.buttons.save = true;

			if (readonly.value) {
				validationInProgress.value = false;
				refreshSystemStatus();
				return (isValidHead && isValidTable);
			}

			await allowUiToRender();
			buildValidationRequest();
			await allowUiToRender();

			// Capture the edit generation and an abort handle so a newer edit can supersede/cancel this run
			const runEditId = latestEditId;
			const abortController = new AbortController();
			activeValidationAbortController = abortController;

			try {
				const validationResponse = await documentApi.validateDocument(props.documentId, validationRequest, { signal: abortController.signal });

				// A newer edit superseded this run: discard the response so it can't overwrite newer changes.
				if (runEditId !== latestEditId) {
					validationInProgress.value = false;
					refreshSystemStatus();
					return false;
				}

				const validationFields = validationResponse.fields!;

				if (isValidationTableCellFocused()) {
					// A cell is being edited. Replacing tables.value would rebuild the table and unmount the focused
					// input (dropping keystrokes), so merge the response values/states into the existing cells

					hasDeferredTableValidationResult = !applyTableValidationResultInPlace(validationResponse.tables ?? []);
				} else {
					hasDeferredTableValidationResult = false;

					tables.value = validationResponse.tables ?? [];

					// Synchronize activeTable.value with the new tables array
					// to prevent stale reference after validation response overwrites tables
					if (activeTableId.value) {
						const table = tables.value.find(t => t.id === activeTableId.value);
						if (table) {
							activeTable.value = table;
						}
					}
				}

				await allowUiToRender();
				isValidHead = handleValidationFieldResponse(validationFields);
				await allowUiToRender();
				isValidTable = await handleValidationTableResponse(tables.value);

				if (isValidHead && isValidTable && !isReadOnlyMode.value) {
					blocked.buttons.save = false;
				}

				await getAllErrorMessages();

				// If there is no table splitter, check if the active table has lines. If it has, always show
				if (!tableSplitterSetAfterValidation.value) {
					const table = tables.value.find(currTable => currTable.id === activeTableId.value);
					if (table) {
						checkTableBehaviour(table);
						getActiveTable();
						toggleResultList();
					}

					tableSplitterSetAfterValidation.value = true;
				}
			} catch (reason: any) {
				// Aborted by a newer edit — not an error.
				if (reason?.name === 'AbortError') {
					validationInProgress.value = false;
					refreshSystemStatus();
					return false;
				}

				if (reason.json == null) {
					ToastManager.showError(toast, t('Squeeze.Validation.Error'), String(reason));
				}
				else {
					const completeResponse = await reason.json() as ErrorDto;
					ToastManager.showError(toast, t('Squeeze.Validation.Error'), t('Squeeze.Validation.Dialogs.SaveDocument.Error') + "\n" + completeResponse.message);
				}

				isValidHead = isValidTable = false;
			} finally {
				// Clear the abort handle unless a newer run already replaced it.
				if (activeValidationAbortController === abortController) {
					activeValidationAbortController = null;
				}
			}

			validationInProgress.value = false;
			refreshSystemStatus();
			return (isValidHead && isValidTable);
		}

		const flushQueuedValidation = () => {
			if (activeValidationPromise || !queuedValidationRequest) {
				return;
			}

			const currentRequest = queuedValidationRequest;
			queuedValidationRequest = null;

			activeValidationPromise = runValidateDocument(currentRequest.manuellyTriggered)
				.then((result) => {
					currentRequest.resolvers.forEach((resolve) => resolve(result));
					return result;
				})
				.catch(() => {
					currentRequest.resolvers.forEach((resolve) => resolve(false));
					return false;
				})
				.finally(() => {
					activeValidationPromise = null;
					if (!queuedValidationRequest) {
						validationPending.value = false;
						refreshSystemStatus();
					}
					flushQueuedValidation();
				});
		};

		const validateDocument = (manuellyTriggered = false) => {
			validationPending.value = true;
			refreshSystemStatus();

			if (activeValidationPromise) {
				return new Promise<boolean>((resolve) => {
					if (queuedValidationRequest) {
						queuedValidationRequest.manuellyTriggered = queuedValidationRequest.manuellyTriggered || manuellyTriggered;
						queuedValidationRequest.resolvers.push(resolve);
						return;
					}

					queuedValidationRequest = {
						manuellyTriggered,
						resolvers: [resolve],
					};
				});
			}

			return new Promise<boolean>((resolve) => {
				queuedValidationRequest = {
					manuellyTriggered: queuedValidationRequest?.manuellyTriggered || manuellyTriggered,
					resolvers: [...(queuedValidationRequest?.resolvers ?? []), resolve],
				};
				flushQueuedValidation();
			});
		}

		/** Cancels any queued auto-validation so only the newest request can still run. */
		function cancelScheduledValidation() {
			scheduledValidationRunId++;
			initialBackgroundValidationRunId++;
			validationPending.value = false;
			refreshSystemStatus();

			if (scheduledValidationTimeoutId !== null) {
				window.clearTimeout(scheduledValidationTimeoutId);
				scheduledValidationTimeoutId = null;
			}

			if (queuedValidationRequest) {
				queuedValidationRequest.resolvers.forEach((resolve) => resolve(false));
			}
			queuedValidationRequest = null;
		}

		/** Queues document validation with debounce so rapid UI changes collapse into one run. */
		function scheduleDocumentValidation(manuellyTriggered = false) {
			// New edit supersedes any older run and aborts the running request so this one isn't queued behind it
			latestEditId++;
			activeValidationAbortController?.abort();

			cancelScheduledValidation();
			validationPending.value = true;
			refreshSystemStatus();

			const currentRunId = scheduledValidationRunId;
			scheduledValidationTimeoutId = window.setTimeout(() => {
				scheduledValidationTimeoutId = null;

				if (currentRunId !== scheduledValidationRunId) {
					return;
				}

				void validateDocument(manuellyTriggered);
			}, 80);
		}

		/** On leaving the table, re-validate if a result was deferred during editing so the fresh table gets rendered. */
		const onValidationPanelFocusOut = (event: FocusEvent) => {
			if (!hasDeferredTableValidationResult) {
				return;
			}
			const panel = document.querySelector('.validation-table-panel');
			if (!panel) {
				return;
			}
			const nextTarget = event.relatedTarget as Node | null;
			// Ignore focus moves that stay inside the table (cell-to-cell navigation).
			if (nextTarget && panel.contains(nextTarget)) {
				return;
			}
			hasDeferredTableValidationResult = false;
			scheduleDocumentValidation();
		};

		/**
		 * Queues the first validation after the view became interactive to keep initial paint responsive.
		 */
		const scheduleInitialBackgroundValidation = () => {
			const currentRunId = ++initialBackgroundValidationRunId;
			window.setTimeout(() => {
				if (currentRunId !== initialBackgroundValidationRunId) {
					return;
				}

				void validateDocument(true);
			}, 0);
		};

		/**
		 * Set the Viewer BoundingBox values in values
		 * @param values
		 * @param boundingBox
		 */
		const mapBoundingBoxDtoToViewerBbox = (values: BoundingBox, boundingBox: BoundingBoxOld) => {
			values.x0 = boundingBox.left;
			values.y0 = boundingBox.top;
			values.x1 = boundingBox.right;
			values.y1 = boundingBox.bottom;
		}

		/**
		 * Return index of document field
		 * @param name
		 */
		const getDocumentFieldIndex = (name: string) => {
			return documentFields.value.findIndex(field => field.name == name);
		}

		/**
		 * Synchronize activeTable with the new tables array
		 */
		const syncActiveTable = () => {
			const idx = tables.value.findIndex(t => t.id === activeTableId.value);
			if (idx !== -1 && activeTable.value) {
				tables.value[idx] = JSON.parse(JSON.stringify(activeTable.value));
			}
		}

		/**
		 * On viewer area selected
		 * @param payload
		 */
		const onViewerAreaSelected = async (payload: { words: string[]; boundingBox: BoundingBox }) => {
			// Only used by new Squeeze-Viewer
			const { words, boundingBox } = payload;

			// console.log('onViewerAreaSelected', payload);

			// if (words && words.length) {
			// 	const str = encodeURIComponent(words.join(' '));
			// 	const url = ClientManager.getInstance().getSqueezeBasePath() + `/util/rpc/formatString?str=${str}`;
			// 	const res = await fetch(url, {
			// 		method: 'GET',
			// 		headers: { Authorization: this.getUserAuth() },
			// 	});
			// 	const formatted = await res.json();

			// 	console.log('formatted response in onViewerAreaSelected', formatted);
			// }

			// if readOnlyMode true, then prevent to get the value of draw area in viewer
			if (isReadOnlyMode.value && (!showHeadTraining.value && !showPositionTraining.value && !showFormHeadTraining.value && !showFormPositionTraining.value)) {
				return
			}

			const value = words.join(' ');
			const boundingBoxOld: BoundingBoxOld = {
				bottom: boundingBox.y1 || 0,
				left: boundingBox.x0 || 0,
				right: boundingBox.x1 || 0,
				top: boundingBox.y0 || 0,
				page: String(boundingBox.page || 0),
			};

			viewerMarkedRegions.value = [boundingBox];

			if (showHeadTraining.value) {
				if (activeFieldTraining.value === 'keyWordPattern') {
					if (value === trainingValues.keyWordPattern) {
						trainingValues.keyWordPattern = '';
					}
					await nextTick();
					trainingValues.keyWordPattern = value;
					if (trainingValues.keyWordRegion) {
						mapBoundingBoxDtoToViewerBbox(trainingValues.keyWordRegion, boundingBoxOld);
					}
				}
				if (activeFieldTraining.value === 'valuePattern') {
					if (value === trainingValues.valuePattern) {
						trainingValues.valuePattern = '';
					}
					await nextTick();
					trainingValues.valuePattern = value;
					if (trainingValues.valueRegion) {
						mapBoundingBoxDtoToViewerBbox(trainingValues.valueRegion, boundingBoxOld);
					}
				}
			} else if (showPositionTraining.value) {
				if (activePositionTraining.value === 'valuePattern') {
					if (value === positionTrainingValues.valuePattern) {
						positionTrainingValues.valuePattern = '';
					}
					await nextTick();
					positionTrainingValues.valuePattern = value;
				}
				if (activePositionTraining.value === 'columnRegion') {
					if (positionTrainingValues.columnRegion) {
						mapBoundingBoxDtoToViewerBbox(positionTrainingValues.columnRegion, boundingBoxOld);
					}
				}
			} else if (showFormHeadTraining.value || showFormPositionTraining.value) {
				if (activeFieldTraining.value === 'indicatorKeyWordPattern') {
					if (value === indicatorOfFormTraining.keyWordPattern) {
						indicatorOfFormTraining.keyWordPattern = '';
					}
					await nextTick();
					indicatorOfFormTraining.keyWordPattern = value;
					if (indicatorOfFormTraining.keyWordRegion) {
						mapBoundingBoxDtoToViewerBbox(indicatorOfFormTraining.keyWordRegion, boundingBoxOld);
						indicatorOfFormTraining.keyWordRegion.page = Number(boundingBoxOld.page);
					}
				}

				if (activeFieldTraining.value === 'headFieldValuePattern') {
					if (value === headFieldOfRegionInFormTraining.valuePattern) {
						headFieldOfRegionInFormTraining.valuePattern = '';
					}
					await nextTick();
					headFieldOfRegionInFormTraining.valuePattern = value;
					if (headFieldOfRegionInFormTraining.valueRegion) {
						mapBoundingBoxDtoToViewerBbox(headFieldOfRegionInFormTraining.valueRegion, boundingBoxOld);
						headFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'itemFieldValuePattern') {
					if (value === itemFieldOfRegionInFormTraining.valuePattern) {
						itemFieldOfRegionInFormTraining.valuePattern = '';
					}
					await nextTick();
					itemFieldOfRegionInFormTraining.valuePattern = value;
					if (itemFieldOfRegionInFormTraining.valueRegion) {
						mapBoundingBoxDtoToViewerBbox(itemFieldOfRegionInFormTraining.valueRegion, boundingBoxOld);
						itemFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'regionAnchorKeyWordPattern') {
					if (value === regionAnchorOfFormTraining.keyWordPattern) {
						regionAnchorOfFormTraining.keyWordPattern = '';
					}
					await nextTick();
					regionAnchorOfFormTraining.keyWordPattern = value;
					if (regionAnchorOfFormTraining.keyWordRegion) {
						mapBoundingBoxDtoToViewerBbox(regionAnchorOfFormTraining.keyWordRegion, boundingBoxOld);
						regionAnchorOfFormTraining.keyWordRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'regionAnchorRegion') {
					if (regionAnchorOfFormTraining.keyWordRegion) {
						mapBoundingBoxDtoToViewerBbox(regionAnchorOfFormTraining.keyWordRegion, boundingBoxOld);
						regionAnchorOfFormTraining.keyWordRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'indicatorRegion') {
					if (indicatorOfFormTraining.keyWordRegion) {
						mapBoundingBoxDtoToViewerBbox(indicatorOfFormTraining.keyWordRegion, boundingBoxOld);
						indicatorOfFormTraining.keyWordRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'headFieldValueRegion') {
					if (headFieldOfRegionInFormTraining.valueRegion) {
						mapBoundingBoxDtoToViewerBbox(headFieldOfRegionInFormTraining.valueRegion, boundingBoxOld);
						headFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBoxOld.page);
					}
				}
				if (activeFieldTraining.value === 'itemFieldValueRegion') {
					if (itemFieldOfRegionInFormTraining.valueRegion) {
						mapBoundingBoxDtoToViewerBbox(itemFieldOfRegionInFormTraining.valueRegion, boundingBoxOld);
						itemFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBoxOld.page);
					}
				}
			} else {
				if (activeDocumentField && activeDocumentField.id) {
					// FIXME: Is there a better way to assert non-null?
					const fieldIndex = getDocumentFieldIndex(activeDocumentField.name as any);
					const documentField = documentFields.value[fieldIndex];

					if (documentField && !activeDocumentField.readonly) {
						const documentFieldValue = documentField.value;
						if (documentFieldValue) {
							if (documentField.dataType?.toLowerCase() == "amount") {
								documentFieldValue.value = formatAmount(value);
							} else {
								documentFieldValue.value = value;
							}

							if (documentField && documentField.lookup && documentField.lookup.active && !documentField.lookup.allowCustomValues) {
								const eventSent = {
									query: documentFieldValue.value,
								}

								if (validationFieldSet.value[documentField.fieldGroupId as any]) {
									await validationFieldSet.value[documentField.fieldGroupId as any].checkAutocompleteValues(eventSent as any, documentField as any, documentFieldValue.value);
								}
							}

							documentFieldValue.boundingBox = boundingBox;
							await validateDocument();
						}
					}
				}
				else if (activeTable.value && activeTableCell.value.columnId) {
					const column = (activeTable.value.columns || []).find(column => column.name === activeTableCell!.value!.columnName);

					if (column && column.dataType && !column.readonly) {
						if (column.dataType.toLowerCase() == "amount") {
							activeTableCell.value.value = formatAmount(value);
						} else {
							activeTableCell.value.value = value;
						}

						// Synchronize parent state immediately
						syncActiveTable();

						if (column.lookup && column.lookup.active && !column.lookup.allowCustomValues) {
							const eventSent = {
								query: activeTableCell.value.value,
							}

							if (tableInValidation.value[activeTableId.value as any]) {
								await tableInValidation.value[activeTableId.value as any].checkAutocompleteValues(eventSent as any, column as any, activeTableCell.value, activeTableCell.value.value, activeTableRowIndex.value);
							}
						}

						await validateDocument();
					}
				}
			}
		}

		/**
		 * Triggered when the table structure has been changed (i.e. the order has been changed or a row was deleted or added)
		 * @param tableSet
		 * @param skipValidateOfDocument
		 */
		const changeTableData = async (tableSet: any, skipValidateOfDocument: boolean = false) => {
			if (!skipValidateOfDocument) {
				validationPending.value = true;
				refreshSystemStatus();
			}
			const tableIndex = tables.value.findIndex((table: DocumentTable) => table.id === activeTableId.value);
			if(tableIndex == -1) {
				if (!skipValidateOfDocument) {
					validationPending.value = false;
					refreshSystemStatus();
				}
				return null;
			}

			tables.value[tableIndex] = tableSet;
			activeTable.value = tableSet;

			if (!skipValidateOfDocument) {
				await validateDocument();
			}
		}

		/**
		 * Triggered when a Table Cell is focused
		 * @param cell
		 * @param row
		 * @param index
		 * @param field
		 */
		const onFocusTableCell = (cell: DocumentTableCell, row: DocumentTableRow, index: number, field: DocumentField) => {
			currentErrorField.value = field;
			activeTableCell.value = cell;
			activeTableRowIndex.value = index;
			activeDocumentField.id = 0; // invalidate activeDocument field
			// Only used by v1 viewer
			if (viewerClient.value) {
				if (store.state.userSettings.viewSettings.viewerSettings.highlightOptions.positionTable
					&& store.state.userSettings.viewSettings.viewerSettings.highlightOptions.positionTable.markCell
					&& row.cells
					&& row.cells.length > 0)
				{
					const regions: BoundingBox[] = [];
					row.cells.forEach(cell => {
						if (cell.value && cell.boundingBox) {
							regions.push(cell.boundingBox);
						}
					});
					viewerClient.value.markRegions(regions);
				} else if (row.value && row.value.boundingBox) {
					viewerClient.value.markRegion(row.value.boundingBox);
				}
			} else {
				// Only used by new Squeeze-Viewer
				if (store.state.userSettings.viewSettings.viewerSettings.highlightOptions.positionTable
					&& store.state.userSettings.viewSettings.viewerSettings.highlightOptions.positionTable.markCell
					&& row.cells
					&& row.cells.length > 0)
				{
					viewerMarkedRegions.value = [];
					row.cells.forEach(cell => {
						if (cell.value && cell.boundingBox) {
							viewerMarkedRegions.value.push(cell.boundingBox);
						}
					});
				} else if (row.value && row.value.boundingBox) {
					viewerMarkedRegions.value = [row.value.boundingBox];
				}
			}
		}

		/** Triggered when nextTableCell is undefined - focus last headField */
		const focusLastHeadField = () => {
			const prevGroup = headRefFieldElements.value.slice(-1)[0];
			const prevElement = prevGroup.slice(-1)[0];
			const prevGroupIndex = headRefFieldElements.value.findIndex((group: any) => group === prevGroup);
			const prevElementIndex = prevGroup.findIndex((field: any) => field === prevElement);

			headRefFieldElements.value[prevGroupIndex][prevElementIndex].element.$el.focus();
		}

		/**
		 * Get all tableRefCells of a table
		 * @param tableRefCells
		 */
		const allTableRefCells = (tableRefCells: any) => {
			allTableRefElements.value.push(tableRefCells);
		}

		/** Download the current Attachment in Validation (as ZIP file) */
		const downloadAttachment = () => {
			const downloadURL = ClientManager.getInstance().buildDocumentDownloadUrl(props.documentId);
			window.open(downloadURL);
		}

		/** Init the dialog options */
		const initDialogOptions = async () => {
			try {
				dialogs.deleteDocument.options = (await documentClassApi.getDocumentClassDeleteReasons(props.documentClassId))
					// Filter only active reasons
					.filter((reason: DocumentClassDeleteReason) => Boolean(reason.active))
					// Apply existing sortings
					.sort((a: DocumentClassDeleteReason, b: DocumentClassDeleteReason) => Number(a.sortOrder ?? 0) - Number(b.sortOrder ?? 0))
					.map((reason: DocumentClassDeleteReason) => {
						const reasonName = String(reason.name ?? 'Unknown');
						const translatedString = te('Squeeze.Validation.Dialogs.DeleteDocument.Reasons.' + reasonName) ? t('Squeeze.Validation.Dialogs.DeleteDocument.Reasons.' + reasonName) : getTranslatedDescription(reason) || reasonName
						return {
							label: translatedString,
							value: reasonName,
							requiresComment: Boolean(reason.textfield),
						};
					});
			} catch (response) {
				dialogs.deleteDocument.options = [];
				const errorMessage = (await response.json()).message ?? response.statusText;
				ToastManager.showError(toast, t('Squeeze.General.Error'), `${t('Squeeze.General.Error')}: ${errorMessage}`);
			}
		}

		/**
		 * Shows selected dialog and closes every other dialog
		 * @param selectedDialog
		 */
		const showDialog = (selectedDialog: string) => {
			for (const [dialog, configuration] of Object.entries(dialogs)) {
				(configuration as any).display = (dialog.toLowerCase() === selectedDialog.toLowerCase());
			}
		}

		/** Extracts the Document again */
		const extractDocument = async () => {
			loaded.value = false;
			const nextDocumentId = await getNextDocument(true);
			documentApi.extractDocument(props.documentId)
				.then(() => {
					loaded.value = true;
					handleNextDocumentId(nextDocumentId);
				})
				.catch(response => response.json().then ((err: { message: string }) => {
					loaded.value = true;
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
		}

		/**
		 * Execute the custom action in validation
		 * @param actionId
		 */
		const executeCustomValidationAction = (actionId: string) => {
			resetSelectedRows.value = false;
			buildValidationRequest();
			validationApi.executeCustomValidationAction(actionId, props.documentId, validationRequest)
				.then((actionResponse: CustomValidationActionResponseDto) => {
					if (actionResponse.errorMessage) {
						ToastManager.showError(toast, t('Squeeze.General.Error'), actionResponse.errorMessage);
						return;
					}

					// show document which is in return value
					switch(actionResponse.returnType) {
					case 'showDocument': {
						if (!actionResponse.returnValue.documentId) {
							return;
						}
						gotoDocument(Number(actionResponse.returnValue.documentId));
						break;
					}
					case 'stay': {
						if (actionResponse.fields) {
							handleValidationFieldResponse(actionResponse.fields);
						}
						if (actionResponse.tables) {
							resetSelectedRows.value = true;
							tables.value = actionResponse.tables;
						}
						scheduleDocumentValidation();
						break;
					}
					}

					// set returnValue message
					customActionDialogMessage.value  = actionResponse.returnValue.message;
				})
				.catch(reason => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), reason);
				})
				.finally(() => {
					// show dialog when the custom action has a message
					if (customActionDialogMessage.value) {
						showCustomActionDialog.value = true;
					}
				})
		}

		/** Init the toolbar options. Otherwise, the changes of the disabled attribute might not be realized */
		const initToolbarOptions = () => {
			toolbarOptions.value = [
				{
					label: t('Squeeze.Validation.Extraction.RecreateResult'),
					icon: 'mdi mdi-file-restore-outline',
					disabled: blocked.buttons.extract,
					command: () => {
						extractDocument();
					},
				},
				{
					label: t('Squeeze.Validation.Dialogs.ChangeDocumentClass.Change'),
					icon: 'mdi mdi-file-document-edit-outline',
					disabled: blocked.buttons.changeDocumentClass,
					command: () => {
						showDialog("changeDocumentClass");
					},
				},
				{
					label: t('Squeeze.Validation.Email.SendMail'),
					icon: 'mdi mdi-email-send-outline',
					disabled: false,
					command: () => {
						showDialog("sendMail");
					},
				},
				{
					label: t('Squeeze.Validation.Dialogs.SplitDocument.SplitCommand'),
					icon: 'mdi mdi-file-compare',
					disabled: blocked.buttons.split,
					command: () => {
						showSplitDocument.value = true;
						loaded.value = false;
						hideTableButtons.value = true;
						hideValidationButtons.value = true;
						showTableSplitter.value = false;
					},
				},
				{
					label: t('Squeeze.Training.Trainings'),
					icon: 'mdi mdi-folder-text-outline',
					items: [
						{
							label: t('Squeeze.Training.FieldTraining'),
							icon: 'mdi mdi-form-textbox',
							disabled: blocked.buttons.training,
							command: () => {
								showHeadTraining.value = true;
								loaded.value = false;
								hideTableButtons.value = true;
								hideValidationButtons.value = true;
								showTableSplitter.value = false;
								showPositionTraining.value = false;
								showFormHeadTraining.value = false;
								showFormPositionTraining.value = false;
								showOcrResults.value = false;
								showLocatorTest.value = false;

								// reset markedRegions in viewer
								viewerMarkedRegions.value = [];
							},
						},
						{
							label: t('Squeeze.Training.PositionTraining'),
							icon: 'mdi mdi-table',
							disabled: blocked.buttons.training,
							command: () => {
								showPositionTraining.value = true;
								loaded.value = false;
								hideTableButtons.value = true;
								hideValidationButtons.value = true;
								showTableSplitter.value = false;
								showHeadTraining.value = false;
								showFormHeadTraining.value = false;
								showFormPositionTraining.value = false;
								showOcrResults.value = false;
								showLocatorTest.value = false;
							},
						},
					],
				},
				{
					label: t('Squeeze.Attachments.ZIPDownlaod'),
					icon: 'mdi mdi-folder-download-outline',
					command: () => {
						downloadAttachment();
					},
				},
				{
					label: t('Squeeze.DocumentClasses.OCRResults'),
					icon: 'mdi mdi-ocr',
					command: () => {
						showOcrResults.value = true;
						loaded.value = false;
						hideTableButtons.value = true;
						hideValidationButtons.value = true;
						showTableSplitter.value = false;
						showHeadTraining.value = false;
						showPositionTraining.value = false;
						showFormHeadTraining.value = false;
						showFormPositionTraining.value = false;
						showLocatorTest.value = false;

						// reset markedRegions in viewer
						viewerMarkedRegions.value = [];
					},
				},
				{
					label: t('Squeeze.Locators.Test'),
					icon: 'mdi mdi-folder-text-outline',
					disabled: blocked.buttons.testing,
					command: () => {
						showLocatorTest.value = true;
						loaded.value = false;
						hideTableButtons.value = true;
						hideValidationButtons.value = true;
						showTableSplitter.value = false;
						showHeadTraining.value = false;
						showPositionTraining.value = false;
						showFormHeadTraining.value = false;
						showFormPositionTraining.value = false;
						showOcrResults.value = false;

						// reset markedRegions in viewer
						viewerMarkedRegions.value = [];
					},
				},
				{
					label: t('Squeeze.Validation.General.AddAttachment'),
					icon: 'mdi mdi-cloud-upload-outline',
					disabled: blocked.buttons.attachment,
					command: () => {
						showUpload.value = true;
					},
				},
				...(store.state.featureSet.v2ValidationTable ? [{
					label: t('Squeeze.Validation.General.Table') + " " + (useV2ValidationTable.value ? 'V1' : 'V2'),
					icon: useV2ValidationTable.value ? 'mdi mdi-rotate-left' : 'mdi mdi-table',
					command: () => {
						if (useV2ValidationTable.value) {
							confirm.require({
								message: t('Squeeze.Validation.Dialogs.SwitchToLegacyTable'),
								header: t('Squeeze.General.Confirmation'),
								icon: 'mdi mdi-alert-outline',
								acceptLabel: t('Squeeze.General.Yes'),
								rejectLabel: t('Squeeze.General.No'),
								accept: () => {
									toggleValidationTableV2();
								},
							});
							return;
						}

						toggleValidationTableV2();
					},
				}] : []),
				{
					label: t('Squeeze.Validation.Help'),
					icon: 'mdi mdi-comment-question-outline',
					command: () => {
						showHotKeyList.value = true;
					},
				},
			]

			if (store.state.scopes.sqzAdmin && store.state.featureSet.documentLog) {
				toolbarOptions.value.push(
					{
						label: t('Squeeze.Validation.Log.Log'),
						icon: 'mdi mdi-script-text-outline',
						command: () => {
							showLog.value = true;
						},
					}
				)
			}

			if (store.state.featureSet.formTraining) {
				const indexOfTrainingMenu = toolbarOptions.value.findIndex(option => option.label === t('Squeeze.Training.Trainings'));
				if (indexOfTrainingMenu) {
					toolbarOptions.value[indexOfTrainingMenu].items.push(
						{
							label: t('Squeeze.Training.FormBasedHeadTraining'),
							icon: 'mdi mdi-form-textarea',
							disabled: blocked.buttons.training,
							command: () => {
								showFormHeadTraining.value = true;
								loaded.value = false;
								hideTableButtons.value = true;
								hideValidationButtons.value = true;
								showTableSplitter.value = false;
								showHeadTraining.value = false;
								showPositionTraining.value = false;
								showFormPositionTraining.value = false;
								showOcrResults.value = false;
								showLocatorTest.value = false;

								// reset markedRegions in viewer
								viewerMarkedRegions.value = [];
							},
						},
						{
							label: t('Squeeze.Training.FormBasedPositionTraining'),
							icon: 'mdi mdi-file-table-outline',
							disabled: blocked.buttons.training,
							command: () => {
								showFormPositionTraining.value = true;
								loaded.value = false;
								hideTableButtons.value = true;
								hideValidationButtons.value = true;
								showTableSplitter.value = false;
								showHeadTraining.value = false;
								showPositionTraining.value = false;
								showFormHeadTraining.value = false;
								showOcrResults.value = false;
								showLocatorTest.value = false;

								// reset markedRegions in viewer
								viewerMarkedRegions.value = [];
							},
						}
					)
				}
			}

			if (customActions.value && customActions.value.length) {
				// get custom action as menuItem object
				const allActions: CustomAction[] = [];
				customActions.value.map((action: CustomAction) => {
					allActions.push({
						label: action.description,
						icon: 'mdi mdi-square-small',
						command: () => { executeCustomValidationAction(action.id as string) },
					})
				})

				toolbarOptions.value.push(
					{
						label: t('Squeeze.CustomAction.Actions'),
						items: allActions,
					}
				)
			}
		}

		/** Set ToolbarOptions in read only mode, when headTraining|positionTraining|ocrResults|locatorTesting is shown */
		const setToolbarOptionsInReadOnlyMode = () => {
			const isTrainingShown = showHeadTraining.value || showPositionTraining.value || showFormHeadTraining.value || showFormPositionTraining.value;

			if (hideValidationButtons.value) {
				// the document can be extracted again directly from a training view
				blocked.buttons.extract = !isTrainingShown;
				blocked.buttons.changeDocumentClass = true;
				blocked.buttons.split = true;
			} else {
				blocked.buttons.extract = false;
				blocked.buttons.changeDocumentClass = false;
				blocked.buttons.split = !store.state.featureSet.uiAllowDocumentSplit;
			}

			if (readonly.value) {
				blocked.buttons.extract = true;
				blocked.buttons.changeDocumentClass = true;
				blocked.buttons.split = true;
			}

			initToolbarOptions();
		}

		/**
		 * Is clicking the options button, then show toolbarOptions in overlayPanel
		 * @param event
		 */
		const toggleToolBarOptions = (event: any) => {
			setToolbarOptionsInReadOnlyMode();
			const overlayPanel: any = menu.value;
			overlayPanel.toggle(event);
		}

		/** Show or disabled toolbarButton-Text */
		const showToolbarButtonText = async () => {
			const canToggleViewer = isViewerPanelMounted();
			if (canToggleViewer) {
				disableViewerOnResizing();
			}
			/** Check the window size at first load to set the toolbarButtonText to display none */
			if (window.innerWidth <= 1835) {
				toolbarButtonText.value = false;
			}
			toolbarButtonText.value = window.matchMedia('(min-width: 1880px)').matches;

			// disable and enable the viewer by resizing, so that the splitter is dynamic
			await nextTick();
			if (canToggleViewer) {
				enableViewerAfterResizing();
			}
		}

		/** Sets the whole document to read only */
		const setReadOnlyMode = () => {
			isReadOnlyMode.value = true;
			hideTableButtons.value = true;

			blocked.buttons.save = true;
			blocked.buttons.delete = true;
			blocked.buttons.suspend = true;
			blocked.buttons.checkDocument = true;

			blocked.buttons.training = true;
			blocked.buttons.testing = true;
			blocked.buttons.attachment = true;

			// Allow training / locator testing even for processed documents
			if (currentDocument.value!.workflowContext!.step === 'Export' || currentDocument.value!.workflowContext!.step === 'Backup') {
				blocked.buttons.training = false;
				blocked.buttons.testing = false;
			} else if (currentDocument.value!.workflowContext!.step === 'Classification' || currentDocument.value!.workflowContext!.step === 'Extraction') {
				// Enable testing of locators after successful completion of the OCR step
				blocked.buttons.testing = false;
			}

			initToolbarOptions();
			showToolbarButtonText();
		}

		/**
		 * Triggered if the drag dialog is shown
		 * @param event
		 */
		const triggerShowDragDialog = (event: any) => {
			event.preventDefault();

			// check first item of dataTransfer
			const item = event.dataTransfer.items[0];

			if (!item) {
				return;
			}

			if (item.kind === 'string') {
				return
			}

			if (!hideValidationButtons.value && !showUpload.value && !props.isUploadShown) {
				showDragDialog.value = true;
			}
		}

		/** Lock the current document */
		const lockDocument = () => {
			documentApi.lockDocument(props.documentId)
				.then(() => {
					lockedByCurrentUser.value = true;
				})
				.catch(response => response.json().then((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
		}

		/** Unload the current document */
		const onUnload = () => {
			unlockDocument(true);

			// set search request in local storage
			const currentSearchRequestInLocalStorage = localStorage.getItem('searchRequest');
			if (Object.keys(props.searchRequest) && !currentSearchRequestInLocalStorage) {
				localStorage.setItem('searchRequest', JSON.stringify(props.searchRequest));
			}
		}

		/** Get all document classes */
		const getAllDocumentClasses = () => {
			// get document classes from local storage
			const localStorageDocumentClasses = localStorage.getItem('squeeze.validation.documentClasses');
			if (localStorageDocumentClasses) {
				allDocumentClasses.value = JSON.parse(localStorageDocumentClasses);
				return;
			}

			documentClassApi.getAllDocumentClasses()
				.then(data => {
					localStorage.setItem('squeeze.validation.documentClasses', JSON.stringify(data));
					allDocumentClasses.value = data;
				})
				.catch(reason => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), reason);
				});
		}

		/** Get all custom actions */
		const getCustomActions = () => {
			validationApi.getCustomValidationActions()
				.then((scripts: CustomValidationActionDto[]) => {
					const customScripts = scripts.filter(script => script.placement === 'menu');
					if (customScripts) {
						customActions.value = customScripts;
					}
					const customTableScripts = scripts.filter(script => script.placement === 'table');
					if (customTableScripts) {
						customTableActions.value = customTableScripts;
					}
				})
				.catch(response => response.json().then ((err: ErrorDto) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				}))
		}

		/**
		 * On keydown to check the shortcut, so that execute the custom validation action
		 * @param event
		 * @param allCustomActions
		 */
		const onCustomActionShortcut = (event: KeyboardEvent, allCustomActions: CustomValidationActionDto[]) => {
			allCustomActions.forEach((action: CustomValidationActionDto) => {
				if (action && action.shortcut && action.shortcut.key) {
					const currentEventCodeKeys = event.code.match(/[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g);
					if ((currentEventCodeKeys && currentEventCodeKeys[1] === action.shortcut.key.toUpperCase()) && (
						(action.shortcut.ctrl && !action.shortcut.alt && ((event.ctrlKey || event.metaKey) && !event.altKey))
						|| (action.shortcut.ctrl && action.shortcut.alt && (event.altKey && (event.ctrlKey || event.metaKey)))
						|| (action.shortcut.alt && !action.shortcut.ctrl && (event.altKey && (!event.ctrlKey || !event.metaKey))))
					) {
						event.preventDefault();
						executeCustomValidationAction(action.id as string);
					}
				}
			})
		}

		/**
		 * Validates a document and then exports it
		 */
		const validateAndExportDocument = async () => {
			blocked.buttons.save = blocked.buttons.suspend = blocked.buttons.delete = blocked.buttons.menu = blocked.buttons.checkDocument = true;
			buildValidationRequest();
			exportInProgress.value = true;

			try {
				const nextDocumentId = await getNextDocument(true);
				await singlePromiseValidation.execute(documentApi.saveValidateAndExportDocument(props.documentId, validationRequest));
				ToastManager.showSuccess(toast, t('Squeeze.General.Success'), t('Squeeze.Validation.Dialogs.SaveDocument.Success'));
				handleNextDocumentId(nextDocumentId);
			} catch (response) {
				// Check if actually a response object, show generic error if not
				if (response.json == null) {
					ToastManager.showError(toast, t('Squeeze.Validation.Error'), String(response));
					return;
				}

				// Status 400 may be returned if document is invalid, saving failed or export failed
				if (response.status == 400) {
					const completeResponse = await response.json() as SaveValidateAndExportDocumentResponseDto;
					const validationResponseDto = completeResponse.validationResponse;
					// eslint-disable-next-line no-mixed-spaces-and-tabs
					// Document is not valid
					if (validationResponseDto.valid !== true) {
						handleValidationFieldResponse(validationResponseDto.fields!);
						ToastManager.showError(toast, t('Squeeze.Validation.ErrorInvalidDocument'));
						return;
					}

					// Check if all exports are fine
					if (completeResponse.exportException && completeResponse.exportException.message) {
						showExportError.value = true;
						exportErrorMessage.value = completeResponse.exportException.message;
					}
					else if (completeResponse.documentSaveException && completeResponse.documentSaveException.message) {
						showExportError.value = true;
						exportErrorMessage.value = completeResponse.documentSaveException.message;
					}
					else {
						ToastManager.showError(toast, t('Squeeze.Validation.Error'), t('Squeeze.Validation.Dialogs.SaveDocument.Error'));
					}
					blocked.buttons.save = false;
				} else {
					const completeResponse = await response.json() as ErrorDto;
					ToastManager.showError(toast, t('Squeeze.Validation.Error'), t('Squeeze.Validation.Dialogs.SaveDocument.Error') + "\n" + completeResponse.message);
					blocked.buttons.save = false;
				}
			} finally {
				exportInProgress.value = false;
				blocked.buttons.suspend = blocked.buttons.delete = blocked.buttons.menu = blocked.buttons.checkDocument = false;
			}
		}

		/**
		 * Validation Key Combination
		 * @param event
		 */
		const onKeydown = (event: KeyboardEvent) => {
			// validate document - If key strg/ctrl, shift and S pressed, then validates (or check) a document
			if (event.code === "KeyS" && event.shiftKey && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				event.preventDefault();
				if (!blocked.buttons.checkDocument) {
					validateDocument(true);
				}
			}
			// save document - If key strg/ctrl and S pressed, then validates a document and then exports it
			if (event.code === "KeyS" && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				event.preventDefault();
				if (!blocked.buttons.save) {
					validateAndExportDocument();
				}
			}
			// suspend document - If key strg/ctrl and B pressed, then suspend the document
			if (event.code === "KeyB" && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				event.preventDefault();
				if (!blocked.buttons.suspend) {
					showDialog('suspendDocument');
				}
			}
			// delete document - If key strg/ctrl and L pressed, then open the delete dialog of a document
			if (event.code === 'KeyL' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				event.preventDefault();
				// Stop propagation so vue3-excel-editor doesn't open its autocomplete list on Ctrl+L
				event.stopPropagation();
				showDialog('deleteDocument');
			}
			// open hotKey-List - If key F1 pressed, then open the hotKey-List
			if (event.code === 'F1') {
				showHotKeyList.value = !showHotKeyList.value;
			}
			// open headTraining - If key strg/ctrl and F2 pressed, then open the headTraining
			if (event.code === 'F2' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (!blocked.buttons.training) {
					if (showPositionTraining.value || showFormHeadTraining.value || showFormPositionTraining.value || showLocatorTest.value) {
						showPositionTraining.value = false;
						showFormHeadTraining.value = false;
						showFormPositionTraining.value = false;
						showLocatorTest.value = false;

						// reset markedRegions in viewer
						viewerMarkedRegions.value = [];
					}
					showHeadTraining.value = true;
					hideValidationButtons.value = true;
					toggleSplitterTable();
				} else {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Training.NoTrainingAccessMessage', { training: t('Squeeze.Training.FieldTraining')}));
				}
			}
			// open positionTraining - If key strg/ctrl and F3 pressed, then open the positionTraining
			if (event.code === 'F3' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (!blocked.buttons.training) {
					if (showHeadTraining.value || showFormHeadTraining.value || showFormPositionTraining.value || showLocatorTest.value) {
						showHeadTraining.value = false;
						showFormHeadTraining.value = false;
						showFormPositionTraining.value = false;
						showLocatorTest.value = false;
					}
					showPositionTraining.value = true;
					hideValidationButtons.value = true;
					toggleSplitterTable();
				} else {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Training.NoTrainingAccessMessage', { training: t('Squeeze.Training.PositionTraining')}));
				}
			}
			// open Log-List - If key F4 pressed, then open the Log-List
			if (event.code === 'F4' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (store.state.scopes.sqzAdmin && !blocked.buttons.changeDocumentClass) {
					showLog.value = !showLog.value;
				}
			}
			// open locatorTesting - If key strg/ctrl and F12 pressed, then open the locatorTesting
			if (event.code === 'F12' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if(showHeadTraining.value || showPositionTraining.value || showFormHeadTraining.value || showFormPositionTraining.value) {
					showHeadTraining.value = false;
					showPositionTraining.value = false;
					showFormHeadTraining.value = false;
					showFormPositionTraining.value = false;

					// reset markedRegions in viewer
					viewerMarkedRegions.value = [];
				}
				showLocatorTest.value = true;
				hideValidationButtons.value = true;
				toggleSplitterTable();
			}
			// delete current line  - If key strg/ctrl and Entf pressed, then delete the current line
			if (event.code === 'Delete' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey) || event.code === 'Backspace' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (activeTableRowIndex.value) {
					const tableComponent: any = tableInValidation.value[activeTableId.value as any];
					tableComponent.deleteRow(activeTableRowIndex.value);
				}
			}
			// insert a new line  - If key strg/ctrl and Einf pressed, then insert a new line
			if ((event.code === 'Insert' || event.code === 'KeyY') && !event.shiftKey && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (activeTableRowIndex.value) {
					const tableComponent: any = tableInValidation.value[activeTableId.value as any];
					tableComponent.createNewRow(activeTableRowIndex.value as number);
				}
			}
			// copy the current line & insert in next line  - If key strg/ctrl + shift and Einf pressed, then copied the current line and insert in next line
			if ((event.code === 'Insert' || event.code === 'KeyY') && event.shiftKey && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
				if (activeTableRowIndex.value) {
					const tableComponent: any = tableInValidation.value[activeTableId.value as any];
					tableComponent.copyRow(activeTableRowIndex.value as number);
				}
			}

			// v1 viewer shortcuts
			if (viewerClient.value) {
				// viewer-image optimized width - If key POS1 pressed, then optimized the width of viewer-image
				if (event.code === 'Home' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
					viewerClient.value.toggleFullWidth();
				}
				// viewer-image optimized height - If key strg/ctrl and END pressed, then optimized the height of viewer-image
				if (event.code === 'End' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
					viewerClient.value.toggleFullHeight();
				}
				// viewer-image scroll up - If key PageUp pressed, then scroll up in viewer-image
				if (event.code === 'PageUp') {
					event.preventDefault();
					viewerClient.value.pageUp();
				}
				// viewer-image scroll down - If key PageDown pressed, then scroll down in viewer-image
				if (event.code === 'PageDown') {
					event.preventDefault();
					viewerClient.value.pageDown();
				}
			} else if (NEW_SQUEEZE_VIEWER) {
				// v2 viewer shortcuts
				// viewer-image optimized width - If key POS1 pressed, then optimized the width of viewer-image
				if (event.code === 'Home' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
					SqueezeViewer.value.onClickResetZoom();
				}
				// viewer-image optimized height - If key strg/ctrl and END pressed, then optimized the height of viewer-image
				if (event.code === 'End' && (navigator.platform.match("MacIntel") ? event.metaKey : event.ctrlKey)) {
					SqueezeViewer.value.onClickHeightZoom();
				}
				// viewer-image scroll up - If key PageUp pressed, then scroll up in viewer-image
				if (event.code === 'PageUp') {
					event.preventDefault();
					SqueezeViewer.value.openNextPage();
				}
				// viewer-image scroll down - If key PageDown pressed, then scroll down in viewer-image
				if (event.code === 'PageDown') {
					event.preventDefault();
					SqueezeViewer.value.openPreviousPage();
				}
				// viewer-image fixation - If key strg/ctrl and Space pressed, then fixate the viewer-image
				if (event.code === 'Space' && event.ctrlKey) {
					event.preventDefault();
					SqueezeViewer.value.toggleSetView();
				}
			}

			// check length of custom actions in menu to check
			if (customActions.value.length) {
				onCustomActionShortcut(event, customActions.value);
			}

			// check length of custom actions in table
			if (customTableActions.value.length) {
				onCustomActionShortcut(event, customTableActions.value);
			}
		}

		/**
		 * Deletes a document
		 * @param comment
		 */
		const deleteDocument = async (comment: string) => {
			blocked.buttons.delete = true;
			const nextDocumentId = await getNextDocument(true);
			documentApi.deleteDocumentById(props.documentId, comment)
				.then(() => {
					ToastManager.showSuccess(toast, t('Squeeze.General.Success'), t('Squeeze.Validation.Dialogs.DeleteDocument.Success'));
					handleNextDocumentId(nextDocumentId);
				})
				.catch(reason => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Validation.Dialogs.DeleteDocument.Error') + "\n" + reason);
				})
				.finally(()=> {
					dialogs.deleteDocument.display = blocked.buttons.delete = false;
				})
		}

		/**
		 * Suspends a document
		 * @param comment
		 */
		const suspendDocument = async (comment: string) => {
			blocked.buttons.suspend = true;

			buildValidationRequest();
			const nextDocumentId = await getNextDocument(true);
			documentApi.saveAndSuspendDocument(props.documentId, comment, validationRequest)
				.then(() => {
					ToastManager.showSuccess(toast, t('Squeeze.General.Success'), t('Squeeze.Validation.Dialogs.SuspendDocument.Success'));
					handleNextDocumentId(nextDocumentId);
				})
				.catch(reason => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Validation.Dialogs.SuspendDocument.Error') + "\n" + reason);
				})
				.finally(()=> {
					dialogs.suspendDocument.display = blocked.buttons.suspend = false;
				})
		}

		/** Emitted after a mail has been send successfully */
		const afterSendSuccess = () => {
			dialogs.sendMail.display = false;
		}

		/** Saves the new Document Class to a document */
		const saveNewDocumentClass = async () => {
			loaded.value = false;
			dialogs.changeDocumentClass.loading = true;
			const nextDocumentId = await getNextDocument(true);
			documentApi.changeDocumentClass(props.documentId, newDocumentClass.value, dialogs.changeDocumentClass.trainDocument)
				.then(() => {
					loaded.value = true;
					dialogs.changeDocumentClass.display = false;
					handleNextDocumentId(nextDocumentId);
				})
				.catch(response => response.json().then ((err: { message: string }) => {
					loaded.value = true;
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				})).finally(() => dialogs.changeDocumentClass.loading = false)
		}

		/**
		 * Is triggered when the Form changes
		 * @param documentClass
		 * @param trainDocument
		 */
		const onChangeDocumentClassChangeForm = (documentClass: number, trainDocument: boolean) => {
			newDocumentClass.value = documentClass;
			dialogs.changeDocumentClass.trainDocument = trainDocument;
		}

		/** Triggered when the "read only"-button in the Locked Dialog is clicked */
		const onClickDocumentReadOnly = () => {
			dialogs.lockedDocument.display = false;
			mode.value = "readonly";
			isReadOnlyMode.value = true;
			hideTableButtons.value = true;
		}

		/**
		 * Triggered when Enter/Tab-Keydown in first or last fieldGroup field
		 * @param currentFieldGroup
		 * @param isNextField
		 */
		const enterDocumentGroup = async (currentFieldGroup: number, isNextField: boolean) => {
			const currentGroupIndex = documentClassFieldsByGroup.value.findIndex(fieldGroup => fieldGroup.id === currentFieldGroup);

			if(currentGroupIndex !== -1 && !isNextField) {
				// Triggered when a field of headFieldGroup was the first element, then focused the last element in the previous headFieldGroup
				const prevGroupIndex = currentGroupIndex - 1;
				if(prevGroupIndex !== headRefFieldElements.value.length && prevGroupIndex >= 0) {
					activeGroupTab.value = prevGroupIndex;
					await nextTick();
					headRefFieldElements.value[prevGroupIndex][headRefFieldElements.value[prevGroupIndex].length -1].element.$el.focus();
				}
			} else if(currentGroupIndex !== documentClassFieldsByGroup.value.length && isNextField) {
				// Triggered when a field of headFieldGroup was the last element, then focused the next element in the next headFieldGroup
				const nextGroupIndex = currentGroupIndex + 1;
				if(nextGroupIndex !== headRefFieldElements.value.length) {
					activeGroupTab.value = nextGroupIndex;
					await nextTick();
					headRefFieldElements.value[nextGroupIndex][0].element.$el.focus();
				} else {
					// Triggered when last element of headFieldGroup is active, then focus the first cell in table
					const activeTableComponent: any = activeTableId.value ? tableInValidation.value[activeTableId.value as any] : null;
					if (activeTableComponent && typeof activeTableComponent.focusFirstCell === "function") {
						// V2 excel table focus to first cell
						activeTableComponent.focusFirstCell();
					} else if (allTableRefElements.value[0] && allTableRefElements.value[0][0] && allTableRefElements.value[0][0].element && allTableRefElements.value[0][0].element.$el) {
						// Focus for old V1 Table
						allTableRefElements.value[0][0].element.$el.focus();

						if (allTableRefElements.value[0][0].element.$el.firstElementChild) {
							allTableRefElements.value[0][0].element.$el.firstElementChild.focus();
						}
					} else {
						// Triggered when last element of headFieldGroup is active and no more fields or table cells exist
						await validateDocument();
					}
				}
			}
		}

		/**
		 * Triggered when an Autocomplete-Item is hovered and it has an DocumentField-Value
		 * @param fieldValue
		 */
		const onHoverItemAutocomplete = (fieldValue: DocumentFieldValue) => {
			if (fieldValue.boundingBox) {
				viewerMarkedRegions.value = [fieldValue.boundingBox] as BoundingBox[];
				viewerClient.value?.markRegion(fieldValue.boundingBox);
			}
		}

		/**
		 * Sets the Object for the currently active table
		 * @param {number} tableId Id of the table to get
		 */
		const setActiveTable = (tableId: number) => {
			showTableSplitter.value = true;
			if (!activeTableId.value) {
				activeTableId.value = tableId;
			} else if (activeTableId.value !== tableId) {
				activeTableId.value = tableId;
			} else {
				activeTableId.value = null;
				showTableSplitter.value = false;
			}
			const table = tables.value.find(table => table.id === activeTableId.value);
			activeTable.value = null;

			if (table) {
				activeTable.value = table;
			}
		}

		/** Get user auth */
		const getUserAuth = computed(() => {
			const documentToken = documentTokenUrlParam();
			if (documentToken) {
				// The backend recognizes a document-scoped token the same way as an apiKey, via HTTP_X_API_KEY
				return { 'X-API-KEY': documentToken };
			}

			if (ClientManager.getInstance().login.activeAuth === AuthTypes.Bearer) {
				return { 'Authorization': "Bearer " + bearerToken.value }
			}

			const { username, password } = ClientManager.getInstance().getSqueezeCredentials();
			return { 'Authorization': "Basic " + btoa(`${username}:${password}`) }
		});

		/**
		 * Get document field value
		 * @param fieldName
		 */
		const getDocumentFieldValue = (fieldName: string) => {
			return documentFields.value[getDocumentFieldIndex(fieldName)]?.value?.value;
		}

		const setupViewer = () => {
			// Only used by old Squeeze-Viewer
			const iframe = document.getElementById("SqueezeViewer");
			if (iframe instanceof HTMLIFrameElement && iframe.contentWindow != null) {
				viewerClient.value = new ViewerClient(iframe.contentWindow);

				viewerClient.value.onSelectArea = async (value, boundingBox) => {
					// if readOnlyMode true, then prevent to get the value of draw area in viewer
					if (isReadOnlyMode.value && (!showHeadTraining.value && !showPositionTraining.value && !showFormHeadTraining.value && !showFormPositionTraining.value)) {
						return;
					}

					if (showHeadTraining.value) {
						if (activeFieldTraining.value === 'keyWordPattern') {
							if (value === trainingValues.keyWordPattern) {
								trainingValues.keyWordPattern = '';
							}
							await nextTick();
							trainingValues.keyWordPattern = value;
							if (trainingValues.keyWordRegion) {
								mapBoundingBoxDtoToViewerBbox(trainingValues.keyWordRegion, boundingBox);
							}
						}
						if (activeFieldTraining.value === 'valuePattern') {
							if (value === trainingValues.valuePattern) {
								trainingValues.valuePattern = '';
							}
							await nextTick();
							trainingValues.valuePattern = value;
							if (trainingValues.valueRegion) {
								mapBoundingBoxDtoToViewerBbox(trainingValues.valueRegion, boundingBox);
							}
						}
					} else if (showPositionTraining.value) {
						if (activePositionTraining.value === 'valuePattern') {
							if (value === positionTrainingValues.valuePattern) {
								positionTrainingValues.valuePattern = '';
							}
							await nextTick();
							positionTrainingValues.valuePattern = value;
						}
						if (activePositionTraining.value === 'columnRegion') {
							if (positionTrainingValues.columnRegion) {
								mapBoundingBoxDtoToViewerBbox(positionTrainingValues.columnRegion, boundingBox);
							}
						}
					} else if (showFormHeadTraining.value || showFormPositionTraining.value) {
						if (activeFieldTraining.value === 'indicatorKeyWordPattern') {
							if (value === indicatorOfFormTraining.keyWordPattern) {
								indicatorOfFormTraining.keyWordPattern = '';
							}
							await nextTick();
							indicatorOfFormTraining.keyWordPattern = value;
							if (indicatorOfFormTraining.keyWordRegion) {
								mapBoundingBoxDtoToViewerBbox(indicatorOfFormTraining.keyWordRegion, boundingBox);
								indicatorOfFormTraining.keyWordRegion.page = Number(boundingBox.page);
							}
						}

						if (activeFieldTraining.value === 'headFieldValuePattern') {
							if (value === headFieldOfRegionInFormTraining.valuePattern) {
								headFieldOfRegionInFormTraining.valuePattern = '';
							}
							await nextTick();
							headFieldOfRegionInFormTraining.valuePattern = value;
							if (headFieldOfRegionInFormTraining.valueRegion) {
								mapBoundingBoxDtoToViewerBbox(headFieldOfRegionInFormTraining.valueRegion, boundingBox);
								headFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'itemFieldValuePattern') {
							if (value === itemFieldOfRegionInFormTraining.valuePattern) {
								itemFieldOfRegionInFormTraining.valuePattern = '';
							}
							await nextTick();
							itemFieldOfRegionInFormTraining.valuePattern = value;
							if (itemFieldOfRegionInFormTraining.valueRegion) {
								mapBoundingBoxDtoToViewerBbox(itemFieldOfRegionInFormTraining.valueRegion, boundingBox);
								itemFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'regionAnchorKeyWordPattern') {
							if (value === regionAnchorOfFormTraining.keyWordPattern) {
								regionAnchorOfFormTraining.keyWordPattern = '';
							}
							await nextTick();
							regionAnchorOfFormTraining.keyWordPattern = value;
							if (regionAnchorOfFormTraining.keyWordRegion) {
								mapBoundingBoxDtoToViewerBbox(regionAnchorOfFormTraining.keyWordRegion, boundingBox);
								regionAnchorOfFormTraining.keyWordRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'regionAnchorRegion') {
							if (regionAnchorOfFormTraining.keyWordRegion) {
								mapBoundingBoxDtoToViewerBbox(regionAnchorOfFormTraining.keyWordRegion, boundingBox);
								regionAnchorOfFormTraining.keyWordRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'indicatorRegion') {
							if (indicatorOfFormTraining.keyWordRegion) {
								mapBoundingBoxDtoToViewerBbox(indicatorOfFormTraining.keyWordRegion, boundingBox);
								indicatorOfFormTraining.keyWordRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'headFieldValueRegion') {
							if (headFieldOfRegionInFormTraining.valueRegion) {
								mapBoundingBoxDtoToViewerBbox(headFieldOfRegionInFormTraining.valueRegion, boundingBox);
								headFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBox.page);
							}
						}
						if (activeFieldTraining.value === 'itemFieldValueRegion') {
							if (itemFieldOfRegionInFormTraining.valueRegion) {
								mapBoundingBoxDtoToViewerBbox(itemFieldOfRegionInFormTraining.valueRegion, boundingBox);
								itemFieldOfRegionInFormTraining.valueRegion.page = Number(boundingBox.page);
							}
						}
					} else {
						if (activeDocumentField) {
							// FIXME: Is there a better way to assert non-null?
							const fieldIndex = getDocumentFieldIndex(activeDocumentField.name as any);
							const documentField = documentFields.value[fieldIndex];
							const documentFieldValue = documentFields.value[fieldIndex];

							if(documentField && documentFieldValue && !activeDocumentField.readonly) {
								if (documentField.dataType?.toLowerCase() == "amount") {
									documentFields.value[fieldIndex].value!.value = formatAmount(value as any);
								} else {
									documentFields.value[fieldIndex].value!.value = value;
								}
								scheduleDocumentValidation();
							}
						}
						else if (activeTableCell.value && activeTableCell.value.columnId) {
							const column = activeTable.value!.columns?.find(column => column.name === activeTableCell!.value!.columnName);

							if(column && column.dataType) {
								if (column.dataType.toLowerCase() == "amount") {
									//activeTableCell.value = parseNumbers(value) as any; // TODO: Add Number fields to Table
									activeTableCell.value.value = value;
								} else {
									activeTableCell.value.value = value;
								}
								scheduleDocumentValidation();
							}
						}
					}
				}

				viewerClient.value.onOpenFieldTraining = () => {
					const principal = getDocumentFieldValue("Creditor");
					principal ? viewerClient.value!.openFieldTraining(principal) : ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Viewer.Error.NoCreditorField'));
				}

				viewerClient.value.onOpenItemTraining = () => {
					const principal = getDocumentFieldValue("Creditor");
					principal ? viewerClient.value!.openItemTraining(principal) : ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Viewer.Error.NoCreditorField'));
				}

				viewerClient.value.onOpenFieldTrainingList = () => {
					const principal = getDocumentFieldValue("Creditor");
					principal ? viewerClient.value!.openFieldTrainingList(principal) : ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.Viewer.Error.NoCreditorField'));
				}
			}
		}

		/**
		 * Sort fields by order
		 * @param fieldA
		 * @param fieldB
		 */
		const sortFieldsByOrder = (fieldA: DocumentField, fieldB: DocumentField) => {
			if (fieldA && fieldB) {
				if ((fieldA.sortOrder && fieldB.sortOrder) && (fieldA.sortOrder < fieldB.sortOrder)) {
					return -1;
				}
				if((fieldA.sortOrder && fieldB.sortOrder) && (fieldA.sortOrder > fieldB.sortOrder)) {
					return 1;
				}
			}
			return 0;
		}

		/** Get TrainingKey of DocumentClass */
		const getDocumentClassTrainingKey = async () => {
			let trainingKey:  TrainingKey = {
				'ids': [],
			};

			// get training key from local storage
			const localStorageTrainingKey = localStorage.getItem('squeeze.validation.trainingKey');
			if (localStorageTrainingKey) {
				trainingKey = JSON.parse(localStorageTrainingKey);
			} else {
				await documentClassApi.getDocumentClassTrainingKey(props.documentClassId)
					.then(trainingKeyData => {
						localStorage.setItem('squeeze.validation.trainingKey', JSON.stringify(trainingKeyData));
						trainingKey = trainingKeyData;
					})
					.catch(reason => {
						ToastManager.showError(toast, t('Squeeze.General.Error'), reason);
					})
			}

			const trainingKeyId = trainingKey.ids![0];
			if (trainingKey.ids?.length === 0) {
				blocked.buttons.training = true;
			}
			if (trainingKey.ids!.length !== 1 && trainingKey.ids!.length > 1) {
				blocked.buttons.training = true;
				throw t('Squeeze.Training.MultiTrainingKey');
			}
			documentFields.value.forEach(field => {
				if (field.id === trainingKeyId) {
					trainingKeyField.value = field;
				}
			})
			if (trainingKeyField.value === null && trainingKey.ids!.length === 1) {
				blocked.buttons.training = true;
				throw t('Squeeze.Training.TrainingKeyNotFound');
			}
		}

		/**
		 * Field Layout by rows
		 * @param fieldGroupId Id of the field group
		 */
		const buildFieldLayoutRows = (fieldLayout: GridStackFieldDetails[]) => {
			const rowsByIndex = new Map<number, ValidationFieldLayoutDetails[]>();
			const sortedRows: ValidationFieldLayoutDetails[][] = [];

			fieldLayout.forEach((widget) => {
				const rowIndex = widget.row ?? 0;
				const currentRow = rowsByIndex.get(rowIndex);
				const widgetWithOffset: ValidationFieldLayoutDetails = {...widget};

				if (currentRow) {
					currentRow.push(widgetWithOffset);
				} else {
					rowsByIndex.set(rowIndex, [widgetWithOffset]);
				}
			});

			const rowIndexes = [...rowsByIndex.keys()].sort((a, b) => a - b);
			rowIndexes.forEach((rowIndex) => {
				const rowWidgets = rowsByIndex.get(rowIndex) ?? [];
				rowWidgets.forEach((widget, index) => {
					const widgetOffset = widget.offset ?? 0;
					if (rowWidgets.length === 1) {
						if (widget.width && (widget.width + widgetOffset < 12)) {
							widget.offsetSize = widgetOffset;
						} else if (widget.width && widget.width !== 12 && (widget.width + widgetOffset === 12)) {
							widget.offsetSize = 12 - widget.width;
						}
						return;
					}

					const previousWidget = rowWidgets[index - 1];
					if (widgetOffset > 0 && previousWidget?.width) {
						widget.offsetSize = widgetOffset - previousWidget.width;
						if (previousWidget.offset && previousWidget.width) {
							widget.offsetSize = widgetOffset - (previousWidget.offset + previousWidget.width);
						}
					} else {
						widget.offsetSize = widgetOffset;
					}
				});

				sortedRows.push(rowWidgets);
			});

			return sortedRows;
		}

		/**
		 * Apply the configured layout widths to the fields of a group.
		 * A small lookup map is used here so field width assignment does not repeatedly scan the
		 * complete layout definition for each field of the group.
		 * @param fieldGroup Current field group
		 * @param layoutDetails Layout widgets of the current field group
		 */
		const applyFieldLayoutToGroup = (fieldGroup: DocumentClassFieldGroup, layoutDetails: ValidationFieldLayoutDetails[]) => {
			const layoutByField = new Map<string, ValidationFieldLayoutDetails>();

			layoutDetails.forEach((detail) => {
				if (detail.id != null) {
					layoutByField.set(`id:${detail.id}`, detail);
				}
				if (detail.content) {
					layoutByField.set(`content:${detail.content}`, detail);
				}
			});

			fieldGroup.fields?.forEach((field: FieldInSameLine) => {
				const fieldDetail = layoutByField.get(`id:${field.id}`) ?? layoutByField.get(`content:${field.description}`);
				if (fieldDetail?.width) {
					field.colSize = `p-col-${fieldDetail.width}`;
				}
			});
		}

		/**
		 * Apply all field layouts and cache the prepared row structure by group.
		 * The cached rows are later read directly in the template and avoid repeated `find(...)`
		 * lookups against the full layout array during each render pass.
		 * @param fieldGroups All visible field groups
		 * @param layouts All loaded field group layouts
		 */
		const applyFieldLayoutsToGroups = (fieldGroups: DocumentClassFieldGroup[], layouts: FieldGroupDetails[]) => {
			const rowsByGroup: Record<number, GridStackFieldDetails[][]> = {};
			const layoutByGroupId = new Map<number, FieldGroupDetails>();

			layouts.forEach((layout) => {
				layoutByGroupId.set(layout.fieldGroupId, layout);
			});

			fieldGroups.forEach((fieldGroup) => {
				if (fieldGroup.id == null) {
					return;
				}

				const currentLayout = layoutByGroupId.get(fieldGroup.id);
				if (!currentLayout) {
					return;
				}

				applyFieldLayoutToGroup(fieldGroup, currentLayout.fieldLayout);
				rowsByGroup[fieldGroup.id] = buildFieldLayoutRows(currentLayout.fieldLayout);
			});

			fieldLayoutRowsByGroup.value = rowsByGroup;
		}

		/**
		 * Get the colSize of fields when in same line as previous field
		 * @param line Array with index of fields
		 */
		const setColSize = (line: number[]) => {
			let colSize: string = 'p-col-12';
			switch (line.length) {
			case 2: colSize = 'p-col-6'; break;
			case 3: colSize = 'p-col-4'; break;
			default: break;
			}

			return colSize;
		}

		/**
		 * Set the colSize of current field of field group
		 * @param line Array with index of fields
		 * @param fieldGroup Current field group
		 */
		const setColSizeOfCurrentField = (line: number[], fieldGroup: DocumentClassFieldGroup) => {
			line.forEach((fieldIndex: number) => {
				const currentField: FieldInSameLine = fieldGroup.fields![fieldIndex];
				if (currentField) {
					currentField.colSize = setColSize(line);
					fieldGroup.fields![fieldIndex] = currentField;
				}
			})
		}

		/**
		 * Check which fields of a group share the same line and assign their colSize.
		 */
		const checkSameLineFieldsInGroup = () => {
			let line: number[] = [];
			documentClassFieldsByGroup.value.forEach((group: DocumentClassFieldGroup) => {
				group.fields?.forEach((field: FieldInSameLine, index: number) => {
					if (!field.hidden) {
						if (!field.sameLineAsPreviousField) {
							if (line.length > 0) {
								line.forEach((fieldIndex: number) => {
									const currentField: FieldInSameLine = group.fields![fieldIndex];
									if (currentField) {
										currentField.colSize = setColSize(line);
										group.fields![fieldIndex] = currentField;
									}
								})
								line = [];
								line.push(index);
							} else {
								line.push(index);
							}
						} else {
							if (line.length === 3) {
								line.forEach((fieldIndex: number) => {
									const currentField: FieldInSameLine = group.fields![fieldIndex];
									currentField.colSize = 'p-col-4';
									group.fields![fieldIndex] = currentField;
								})
								line = [];
								line.push(index);
							} else {
								line.push(index);

								// check if is the last field of group, then set colSize
								if(group.fields?.length === index +1) {
									setColSizeOfCurrentField(line, group);
									line = [];
								}
							}
						}
					} else if (field.hidden && group.fields!.length === index +1) {
						// check if is the last field of group hidden, then set colSize
						setColSizeOfCurrentField(line, group);
						line = [];
					}
				})
			})
		}

		/** Get fieldGroup layouts from documentClass */
		const getDocumentClassFieldGroupLayouts = async () => {
			try {
				const response = await documentClassApi.getDocumentClassFieldGroupLayouts(props.documentClassId);
				const fieldLayouts = await response.json() as FieldGroupLayout[];

				const fieldGroupsById = new Map<number, DocumentClassFieldGroup>();
				documentClassFieldsByGroup.value.forEach((fieldGroup) => {
					if (fieldGroup.id != null) {
						fieldGroupsById.set(fieldGroup.id, fieldGroup);
					}
				});

				const normalizedLayoutsByGroupId = new Map<number, FieldGroupLayout>();
				fieldLayouts.forEach((layout) => {
					normalizedLayoutsByGroupId.set(layout.fieldGroupId, layout);
				});

				fieldGroupsById.forEach((_, fieldGroupId) => {
					if (!normalizedLayoutsByGroupId.has(fieldGroupId)) {
						normalizedLayoutsByGroupId.set(fieldGroupId, {
							fieldGroupId,
							fieldLayout: '[]',
						});
					}
				});

				const nextFieldLayoutDetails: FieldGroupDetails[] = [];
				[...normalizedLayoutsByGroupId.values()].forEach((layout) => {
					const parsedLayout = JSON.parse(layout.fieldLayout) as GridStackFieldDetails[];
					if (parsedLayout.length > 0) {
						nextFieldLayoutDetails.push({
							fieldGroupId: layout.fieldGroupId,
							fieldLayout: parsedLayout,
						});
						return;
					}

					const fieldGroup = fieldGroupsById.get(layout.fieldGroupId);
					nextFieldLayoutDetails.push({
						fieldGroupId: layout.fieldGroupId,
						fieldLayout: fieldGroup?.fields?.map((field, fieldGroupIndex) => ({
							id: field.id,
							width: 12,
							row: fieldGroupIndex,
							offset: 0,
							type: 'field',
							fieldGroupId: layout.fieldGroupId,
							documentClassId: props.documentClassId,
						})) ?? [],
					});
				});

				fieldLayoutDetails.value = nextFieldLayoutDetails;
				applyFieldLayoutsToGroups(documentClassFieldsByGroup.value, nextFieldLayoutDetails);
			} catch (response: any) {
				if (!response.json) {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + response);
					return;
				}

				response.json().then ((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				})
			}
		}

		/**
		 * Set focus on the first field of a field group
		 * Triggered also when the field group (tab) is changed
		 */
		const focusOnFirstField = async () => {
			await nextTick();
			const currentFgRefFieldElements = headRefFieldElements.value[activeGroupTab.value];
			// set focus on first InputField or DropdownField
			if (currentFgRefFieldElements && currentFgRefFieldElements[0] && !dialogs.lockedDocument.display) {
				if (currentFgRefFieldElements[0].element.dropdown || currentFgRefFieldElements[0].field.lookup.active) {
					// focus first field when field is a dropdown
					const input = currentFgRefFieldElements[0].element.$el.querySelector('.p-autocomplete-input.p-inputtext');
					input.focus();
				} else {
					currentFgRefFieldElements[0].element.$el.focus();
				}
			}
		}

		/**
		 * Get all headRefField of a fieldGroup
		 * @param headRefField
		 */
		const allHeadRefFields = async (headRefField: any) => {
			// Filter all visible Fields from Array
			const allVisibleFields = headRefField.filter((field: any) => field.field.hidden === false);

			// check if allVisibleFields is not a empty array
			if (allVisibleFields.length > 0) {
				headRefFieldElements.value.push(allVisibleFields);
			}

			// get focus on first field
			await focusOnFirstField();
		}

		/** Get Classification-Classes for Batch-Class */
		const getClassificationClasses = () => {
			if (batchClassId.value) {
				// get classification classes from local storage
				const localStorageClassificationClasses = localStorage.getItem('squeeze.validation.classificationClasses');
				if (localStorageClassificationClasses) {
					dialogs.changeDocumentClass.classificationClasses = JSON.parse(localStorageClassificationClasses);
				} else {
					batchClassApi.getBatchClassClassifications(batchClassId.value)
						.then(data => {
							// Filter out current document class
							const filterData =	data.filter(classificationClass => classificationClass.documentClassId !== Number(route.params.documentClassId));

							// Save Classification Classes to Local Storage
							localStorage.setItem('squeeze.validation.classificationClasses', JSON.stringify(filterData));
							dialogs.changeDocumentClass.classificationClasses = filterData;
						})
						.catch(response => response.json().then ((err: { message: string }) => {
							ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
						}))
				}

				// Disable Button for Change, if there is no Classification Class to Change to
				if (dialogs.changeDocumentClass.classificationClasses && dialogs.changeDocumentClass.classificationClasses.length !== 0) {
					blocked.buttons.changeDocumentClass = true;
				}
			}
		}

		/**
		 * Loads only the document itself for the embedded document-split view. Unlike reloadData(),
		 * this does not touch document-class/master-data endpoints (fields, delete reasons, custom
		 * actions, document classes, ...) that a document-scoped documentToken is not authorized for.
		 */
		const loadEmbeddedDocument = async () => {
			try {
				currentDocument.value = await documentApi.getDocumentById(props.documentId);
				loaded.value = true;
				await nextTick();
				void waitForNextFrame().then(async () => {
					squeezeViewerSplitterPanelReady.value = true;
					await nextTick();
				});
			} catch (reason: any) {
				if (reason.status === 401) {
					router.push({ name: 'ErrorPage', params: { reason: 'notAccess' }, query: { status: reason.status }});
				} else if (reason.status === 403) {
					router.push({ name: 'ErrorPage', params: { reason: 'forbidden' }, query: { status: reason.status }});
				} else {
					// Keep the URL, so the embedding host can retry by simply reloading the frame,
					// and show the error in place of the split view instead of an empty one.
					embeddedLoadFailed.value = true;
					ToastManager.showError(toast, t('Squeeze.General.Error'), reason);
				}
			}
		}

		/** Reload document fields as well as validation fields */
		const reloadData = async () => {
			initialBackgroundValidationRunId++;
			shouldRunInitialBackgroundValidation = false;
			cancelScheduledValidation();
			resetDocumentInteractionState();
			loaded.value = false;
			squeezeViewerSplitterPanelReady.value = false;
			validationTableMountRequested.value = false;
			validationTableReady.value = false;
			validationTableLoadingStatus.value = tableLoadingStatusText.requesting;
			activeGroupTab.value = 0;
			headRefFieldElements.value = [];
			blocked.buttons.save = blocked.buttons.suspend = blocked.buttons.delete = blocked.buttons.menu = blocked.buttons.checkDocument = true;
			// Reload delete reasons
			initDialogOptions();

			let documentClassFieldsPromise = null;
			// get document class fields from local storage
			const localStorageDocumentClassFields = localStorage.getItem('squeeze.validation.documentClassFields');
			if (localStorageDocumentClassFields) {
				documentClassFieldsPromise = JSON.parse(localStorageDocumentClassFields);
			} else {
				// get document class fields from api
				documentClassFieldsPromise = documentClassApi.getAllDocumentClassFields(props.documentClassId);
			}

			const documentPromise = documentApi.getDocumentById(props.documentId);
			viewerShouldObserveResizing.value = false;
			tableSplitterSetAfterValidation.value = false;

			try {
				const [documentClassFieldCollection, document] = await Promise.all([documentClassFieldsPromise, documentPromise]);

				const serializedDocumentClassFields = JSON.stringify(documentClassFieldCollection);
				localStorage.setItem('squeeze.validation.documentClassFields', serializedDocumentClassFields);

				currentDocument.value = document;
				const user = store.state.user;
				const fieldGroups = document.fieldGroups;
				documentClassFieldsByGroup.value = [];
				fieldLayoutRowsByGroup.value = {};

				if (document.workflowContext) {
					Object.assign(documentWorkflowContext, document.workflowContext);
					lockingUserId.value = document.workflowContext.lockedBy!;

					if (document.workflowContext.step !== "Validation" && document.workflowContext.step !== 'Auto-Validation') {
						readonly.value = true;
					} else if (!document.workflowContext.lockedBy) {
						lockDocument();
					} else if (user && user.id === document.workflowContext.lockedBy) {
						lockedByCurrentUser.value = true;
					} else {
						dialogs.lockedDocument.locked = true;
						dialogs.lockedDocument.display = true;
						setReadOnlyMode();
					}
				} else {
					readonly.value = true;
				}

				document.fields.forEach(field => {
					if (field.dataType?.toLowerCase() === "amount") {
						if (field.value != null) {
							if (field.value.value != null) {
								field.value.value = formatAmount(field.value.value);
							} else {
								field.value.value = parseFloat("0") as any;
							}
						}
					}
				});

				batchClassId.value = document.batchClassId!;
				documentFields.value = document.fields;
				tables.value = document.tables;

				loadViewerAlertMessages();

				getDocumentClassTrainingKey();
				getClassificationClasses();

				tables.value.sort((a: any, b: any) => {
					if (a.description && b.description) {
						if (a.description > b.description) {
							return 1;
						}
						else {
							return -1;
						}
					}
					return 0;
				})

				activeTableId.value = null;
				activeTable.value = null;
				for (const table of tables.value) {
					if (table.id && !table.hidden) {
						activeTableId.value = table.id;
						checkTableBehaviour(table);
						getActiveTable();
						break;
					}
				}

				// Group fields once by field group and sort each group once.
				// This replaces repeated filter/sort work for every field group during hydration.
				const documentClassFieldsGrouped = new Map<number, DocumentField[]>();
				documentClassFieldCollection.forEach((field: DocumentField) => {
					const fieldGroupId = field.fieldGroupId;
					if (fieldGroupId == null) {
						return;
					}

					const fieldsOfGroup = documentClassFieldsGrouped.get(fieldGroupId);
					if (fieldsOfGroup) {
						fieldsOfGroup.push(field);
					} else {
						documentClassFieldsGrouped.set(fieldGroupId, [field]);
					}
				});

				documentClassFieldsGrouped.forEach((fieldsOfGroup: DocumentField[]) => {
					fieldsOfGroup.sort(sortFieldsByOrder);
				});

				documentClassFieldsByGroup.value = fieldGroups
					.filter((fieldGroup: any) => fieldGroup.type === 0)
					.map((fieldGroup: any) => ({
						id: fieldGroup.id,
						name: fieldGroup.name,
						description: getTranslatedDescription(fieldGroup),
						type: fieldGroup.type,
						fields: documentClassFieldsGrouped.get(fieldGroup.id!) ?? [],
					}));

				if (store.state.featureSet.validationFieldLayout) {
					if (fieldLayoutDetails.value.length === 0) {
						await getDocumentClassFieldGroupLayouts();
					} else {
						applyFieldLayoutsToGroups(documentClassFieldsByGroup.value, fieldLayoutDetails.value);
					}
				} else {
					checkSameLineFieldsInGroup();
				}

				currentErrorField.value = null;

				let validationResult = true;
				if (hasInitialValidationState()) {
					validationResult = await applyLoadedValidationState();
					shouldRunInitialBackgroundValidation = false;
				} else {
					shouldRunInitialBackgroundValidation = true;
				}

				blocked.buttons.save = !validationResult;
				autoDocumentValidation.value = currentDocument.value!.validateDocumentOnChange ?? true;
			} catch (reason: any) {
				if (reason.status === 401) {
					router.push({ name: 'ErrorPage', params: { reason: 'notAccess' }, query: { status: reason.status }});
				} else if (reason.status === 403) {
					router.push({ name: 'ErrorPage', params: { reason: 'forbidden' }, query: { status: reason.status }});
				} else {
					// Keine Auto-Validierung. Das Dokument zeigt sich mit dem geladenen Zustand, der Nutzer sieht den Fehlerdialog und kann manuell über „Dokument prüfen" die validierung auslösen
					shouldRunInitialBackgroundValidation = false;

					if (allDocumentClasses.value.filter(docClass => docClass.id !== props.documentClassId)) {
						dialogs.errorDocument.display = true;
					} else {
						ToastManager.showError(toast, t('Squeeze.General.Error'), reason);
					}
				}
			} finally {
				loaded.value = true;
				viewerShouldObserveResizing.value = true;
				blocked.buttons.suspend = blocked.buttons.delete = blocked.buttons.menu = blocked.buttons.checkDocument = false;

				if (dialogs.lockedDocument.locked || readonly.value) {
					setReadOnlyMode();
				}

				await nextTick();
				void waitForNextFrame().then(async () => {
					squeezeViewerSplitterPanelReady.value = true;
					await nextTick();

					// Always scroll to top after mounting viewer
					viewerMarkedRegions.value = [{page: 1, x0: 1, x1: 1, y0: 1, y1: 1}];
				});
			}
		}

		/** Unlock viewed document */
		const unlockViewedDocument = async () => {
			await documentApi.unlockDocument(props.documentId)
				.then(() => {
					reloadData();
				})
				.catch((err: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + err.message);
				})
				.finally(() => {
					dialogs.lockedDocument.display = false;
				})
		}

		/** On Route change */
		const onRouteChange = () => {
			if (route.name === "ValidateEntry") {
				nextTick(() => {
					// Mirror onMounted's branching: a document-scoped token does not authorize the
					// document-class/master-data endpoints reloadData() calls, so route changes within
					// the embedded flow (e.g. gotoDocument() after a split) must go through the reduced
					// loadEmbeddedDocument() path instead, same as the initial mount.
					if (isEmbeddedDocumentSplit) {
						loadEmbeddedDocument();
					} else {
						reloadData();
					}
				})
			}
		}

		/**
		 * Change current document in viewer when btn of kosit validation report is clicked
		 * Only when the document is type of xrechnung or zugferd
		 */
		const changeCurrentDocumentInViewer = () => {
			showKositValidationReportFile.value = true;
		}

		/**
		 * Checks if the kosit validation report file is displayed
		 * @param isDocumentDisplayed
		 */
		const isKositValidationReportFileDisplayed = (isDocumentDisplayed: boolean) => {
			if (!isDocumentDisplayed) {
				showKositValidationReportFile.value = false;
			}
		}

		/**
		 * Remove focus on button after click
		 * @param event
		 */
		const removeFocusOnBtnAfterClick = (event: any) => {
			if (event.target.classList.contains('p-button-icon')) {
				event.target.parentElement.blur();
			} else if (event.target.classList.contains('p-button-icon-only')) {
				event.target.blur();
			}
		}

		/** Get and set all validation button settings */
		const getValidationButtonSettings = () => {
			validationApi.getValidationButtonSettings()
				.then(buttonSettings => {
					if (!buttonSettings.length) {
						return;
					}

					buttonSettings.forEach(settings => {
						if (settings.buttonName === ButtonNameEnum.Validate) {
							if (settings.description) {
								validationValidateButtonSettings.value.description = settings.description;
							}
							if (settings.color) {
								validationValidateButtonSettings.value.color = 'background-color: ' + settings.color;
							}
							if (settings.icon) {
								validationValidateButtonSettings.value.icon = 'mdi ' + settings.icon;
							}
						}

						if (settings.buttonName === ButtonNameEnum.Suspend) {
							if (settings.description) {
								validationSuspendButtonSettings.value.description = settings.description;
							}
							if (settings.color) {
								validationSuspendButtonSettings.value.color = 'background-color: ' + settings.color;
							}
							if (settings.icon) {
								validationSuspendButtonSettings.value.icon = 'mdi ' + settings.icon;
							}
						}

						if (settings.buttonName === ButtonNameEnum.Delete) {
							if (settings.description) {
								validationDeleteButtonSettings.value.description = settings.description;
							}
							if (settings.color) {
								validationDeleteButtonSettings.value.color = 'background-color: ' + settings.color;
							}
							if (settings.icon) {
								validationDeleteButtonSettings.value.icon = 'mdi ' + settings.icon;
							}
						}
					});
				}).catch(response => response.json().then ((error: { message: string }) => {
					ToastManager.showError(toast, t('Squeeze.General.Error'), t('Squeeze.General.Error') + ": " + error.message);
				}))
		}

		/** Marks the validation table as ready after the heavy initial mount finished. */
		const onValidationTableMounted = () => {
			validationTableReady.value = true;
			validationTableLoadingStatus.value = tableLoadingStatusText.ready;
			refreshSystemStatus();
		}

		/** Updates the status text shown while the validation table is still loading. */
		const onValidationTableStatusChange = (status: string) => {
			if (status === tableLoadingStatusText.ready) {
				validationTableReady.value = true;
			}

			if (validationTableLoadingStatus.value === status) {
				return;
			}

			validationTableLoadingStatus.value = status;
			refreshSystemStatus();
		}

		/** On page ready */
		onMounted(async () => {
			// get current search request from local storage
			const currentSearchRequestInLocalStorage = localStorage.getItem('searchRequest');
			if (Object.keys(props.searchRequest) && currentSearchRequestInLocalStorage) {
				Object.assign(currentSearchRequest, JSON.parse(currentSearchRequestInLocalStorage));
				localStorage.removeItem('searchRequest');
			}

			window.addEventListener('beforeunload', onUnload, true);
			window.addEventListener('onbeforeunload', onUnload, true);
			window.addEventListener('resize', showToolbarButtonText, true);
			// onKeydown's shortcuts (Ctrl+S/Shift+S/B/L, F2, ...) act on toolbar/table/training state
			// that only exists in the regular view; blocked.buttons.* default to false and are only
			// set by initToolbarOptions()/getValidationButtonSettings(), which the embedded branch
			// below never calls. Without this guard the shortcuts would fire unblocked against
			// document-class field state that was never loaded, and endpoints a document-scoped
			// token isn't authorized for, in a chromeless view with no dialogs/toolbar to show for it.
			if (!isEmbeddedDocumentSplit) {
				window.addEventListener('keydown', onKeydown.bind(this), true);
			}
			window.addEventListener('dragover', triggerShowDragDialog.bind(this), true);
			document.addEventListener('focusout', onValidationPanelFocusOut, true);

			if (route.query.parent && route.query.parent === "QueueList") {
				blockBrowseButtons.value = true;
			}

			if (isEmbeddedDocumentSplit) {
				// A document-scoped token does not authorize document-class/master-data endpoints
				// (button settings, delete reasons, custom actions, document classes, ...). None of
				// those are needed for the chromeless split view anyway, so load only the document
				// itself instead of the full reloadData().
				await showToolbarButtonText();
				setupViewer();
				// Await this before mounting DocumentSplit: its own onMounted immediately fires
				// getDocumentSplitStatus()/getDocumentThumbnails() for the same documentId, so setting
				// showSplitDocument beforehand would race those document-scoped requests against the
				// getDocumentById() authorization check here. Only mount it once that check succeeds;
				// on failure loadEmbeddedDocument() has already set embeddedLoadFailed or navigated to
				// ErrorPage, and there is nothing left to split.
				await loadEmbeddedDocument();
				if (loaded.value) {
					showSplitDocument.value = true;
				}
			} else {
				initToolbarOptions();
				getValidationButtonSettings();
				await showToolbarButtonText();
				//loadQueryParams();
				reloadData();
				setupViewer();
				getAllDocumentClasses();
				getCustomActions();
			}

			// width of left splitter panel by start load
			resizeObserver.value = new ResizeObserver(() => {
				toolbarButtonText.value = leftSplitterPanelContent.value.offsetWidth > 605;
			});

			// observe the leftSplitterPanelContent
			resizeObserver.value.observe(leftSplitterPanelContent.value);
		})

		/** Is triggered before a Component unmounts. Available since Vue 3.0 */
		onBeforeUnmount(() => {
			if (validationLoaderTimeoutId !== null) {
				window.clearTimeout(validationLoaderTimeoutId);
				validationLoaderTimeoutId = null;
			}
			toast.removeGroup(SYSTEM_STATUS_TOAST_GROUP);
			cancelScheduledValidation();
			window.removeEventListener("beforeunload", onUnload, true)
			window.removeEventListener("onbeforeunload", onUnload, true)
			window.removeEventListener('resize', showToolbarButtonText, true);
			if (!isEmbeddedDocumentSplit) {
				window.removeEventListener('keydown', onKeydown.bind(this), true);
			}
			window.removeEventListener('dragover', triggerShowDragDialog.bind(this), true);
			document.removeEventListener('focusout', onValidationPanelFocusOut, true);

			// Remove data from local storage
			localStorage.removeItem('squeeze.validation.documentClasses');
			localStorage.removeItem('squeeze.validation.classificationClasses');
			localStorage.removeItem('squeeze.validation.trainingKey');
			localStorage.removeItem('squeeze.validation.documentClassFields');

			tables.value.forEach(table => {
				ValidationColumnWidthStore.clearCache(table.id!);
			});

			// Unlock document
			unlockDocument(true);

			// Remove the listener when the Component unmounts, otherwise the same listener will be registered multiple times
			if (viewerClient.value) {
				viewerClient.value.removeListener()
			}

			// Clear bearer interval, if one exists
			if (bearerInterval.value) {
				clearInterval(bearerInterval.value);
				bearerInterval.value = null;
			}

			// unobserve the leftSplitterPanelContent
			resizeObserver.value.unobserve(leftSplitterPanelContent.value);
		});

		/** Watch locale to reset locale storage if needed */
		watch(locale, () => {
			initToolbarOptions();
		});

		watch(() => route.params, () => {
			onRouteChange();
		});

		watch(mode, () => {
			switch(mode.value) {
			case "readonly": setReadOnlyMode(); break;
			case "edit": break;
			default: break;
			}
		});

		watch(squeezeViewerSplitterPanelReady, async (isReady) => {
			if (!isReady) {
				return;
			}

			await nextTick();
			await showToolbarButtonText();
			if (!NEW_SQUEEZE_VIEWER) {
				setupViewer();
			}
			if (shouldRunInitialBackgroundValidation) {
				shouldRunInitialBackgroundValidation = false;

				if (store.state.featureSet.v2ValidationTable) {
					scheduleInitialBackgroundValidation();
				} else {
					await validateDocument(true);
				}
			}
			setTimeout(() => {
				validationTableMountRequested.value = true;
			}, 0);
		});

		return {
			getTranslatedDescription,
			t, locale, toast, route, store,
			NEW_SQUEEZE_VIEWER,
			mode,
			isReadOnlyMode,
			tableInteractionReadOnly,
			documentFields,
			allDocumentClasses,
			tables,
			documentClassFieldsByGroup,
			serverBaseUrl,
			loaded,
			squeezeViewerSplitterPanelReady,
			validationTableMountRequested,
			validationTableReady,
			isValidationTableLoaded,
			validationTableLoadingStatus,
			validationInProgress,
			show,
			validationRequest,
			viewerClient,
			activeDocumentField,
			activeTableCell,
			activeTableRowIndex,
			blocked,
			activeTableId,
			activeTable,
			batchClassId,
			newDocumentClass,
			hideTableButtons,
			dialogs,
			toolbarOptions,
			singlePromiseValidation,
			lockedByCurrentUser,
			lockingUserId,
			toolbarButtonText,
			showSplitDocument,
			hideValidationButtons,
			isEmbeddedDocumentSplit,
			verticalSplitterStateKey,
			embeddedLoadFailed,
			embeddedSplitDone,
			showHeadTraining,
			showPositionTraining,
			showFormHeadTraining,
			showFormPositionTraining,
			showLocatorTest,
			showTableSplitter,
			showTableSplitterGutter,
			showOcrResults,
			showDragDialog,
			startTimeByMouseDown,
			activeGroupTab,
			trainingValues,
			trainingKeyField,
			activeFieldTraining,
			positionTrainingValues,
			activePositionTraining,
			indicatorOfFormTraining,
			regionAnchorOfFormTraining,
			headFieldOfRegionInFormTraining,
			itemFieldOfRegionInFormTraining,
			readonly,
			resizeObserver,
			searchElements,
			viewerMarkedRegions,
			viewerShouldObserveResizing,
			showKositValidationReportFile,
			headRefFieldElements,
			allTableRefElements,
			showHotKeyList,
			showLog,
			showUpload,
			uploadLabel,
			files,
			progress,
			allErrorMessages,
			currentErrorField,
			lastRoute,
			blockBrowseButtons,
			exportInProgress,
			showExportError,
			exportErrorMessage,
			fieldLayoutDetails,
			fieldLayoutRowsByGroup,
			customActions,
			customTableActions,
			showCustomActionDialog,
			customActionDialogMessage,
			currentDocument,
			tableSplitterSetAfterValidation,
			currentSearchRequest,
			documentWorkflowContext,
			leftSplitterPanelContent,
			leftSplitterPanel,
			leftSplitterPanelWidth,
			SqueezeViewer,
			viewer,
			menu,
			opBadge,
			tableInValidation,
			documentTypeEnum,
			findTableIndex,
			disableBrowseButtons,
			docBaseUrl,
			viewerDrawingMode,
			viewerSettingsForViewer,
			viewerAlertMessages,
			onViewerClickAlertLink,
			onViewerCloseAlertMessage,
			validationFieldSet,
			resetSelectedRows,
			autoDocumentValidation,
			validationValidateButtonSettings,
			validationSuspendButtonSettings,
			validationDeleteButtonSettings,
			onHoverDocumentType,
			btnDocumentTypeBackgroundColor,
			checkSeverityForStatusMessage,
			checkErrorSeverity,
			toggleErrorMessages,
			goBackToQueueList,
			goBackToValidationList,
			browseLeft,
			gotoDocument,
			goToNextDocument,
			reopenValidationView,
			disableViewerOnResizing,
			enableViewerAfterResizing,
			onSplitterMouseDown,
			onSplitterMouseUp,
			toggleSplitterTable,
			onSplitterResizeEnd,
			onSelectFiles,
			clearFiles,
			removeFile,
			manualFileUpload,
			fileUploader,
			onDragEnter,
			onDragLeave,
			onDrop,
			onFocusFieldTraining,
			onChangePositionTrainingValues,
			onFocusFieldOfPositionTraining,
			onMarkRegion,
			onMarkLines,
			onMarkWord,
			onSplitImageClick,
			onPagesSplit,
			getNextDocument,
			onEmptyList,
			handleNextDocumentId,
			markFieldByRegion,
			formatAmount,
			buildValidationRequest,
			handleValidationFieldResponse,
			handleValidationTableResponse,
			useV2ValidationTable,
			getAllErrorMessages,
			checkTableBehaviour,
			getActiveTable,
			toggleResultList,
			mapBoundingBoxDtoToViewerBbox,
			getDocumentFieldIndex,
			onViewerAreaSelected,
			changeTableData,
			validateDocument,
			scheduleDocumentValidation,
			onFocusTableCell,
			focusLastHeadField,
			allTableRefCells,
			downloadAttachment,
			initDialogOptions,
			showDialog,
			extractDocument,
			initToolbarOptions,
			executeCustomValidationAction,
			setToolbarOptionsInReadOnlyMode,
			toggleToolBarOptions,
			showToolbarButtonText,
			setReadOnlyMode,
			triggerShowDragDialog,
			lockDocument,
			unlockDocument,
			onUnload,
			getAllDocumentClasses,
			getCustomActions,
			onCustomActionShortcut,
			onKeydown,
			validateAndExportDocument,
			deleteDocument,
			suspendDocument,
			afterSendSuccess,
			saveNewDocumentClass,
			onChangeDocumentClassChangeForm,
			onClickDocumentReadOnly,
			enterDocumentGroup,
			onHoverItemAutocomplete,
			setActiveTable,
			getUserAuth,
			getDocumentFieldValue,
			setupViewer,
			sortFieldsByOrder,
			getDocumentClassTrainingKey,
			setColSize,
			setColSizeOfCurrentField,
			checkSameLineFieldsInGroup,
			getDocumentClassFieldGroupLayouts,
			focusOnFirstField,
			allHeadRefFields,
			onValidationTableMounted,
			onValidationTableStatusChange,
			reloadData,
			loadEmbeddedDocument,
			unlockViewedDocument,
			onRouteChange,
			changeCurrentDocumentInViewer,
			isKositValidationReportFileDisplayed,
			removeFocusOnBtnAfterClick,
			XmlValidationStateEnum,
		};
	},
});

</script>
<style lang="scss" scoped>

.root-splitter {
	height: 100vh;
}

/* Class to disabled the splitter gutter of Table, when Table is undefined or hidden */
.disabled-splitter-gutter > ::v-deep(.p-splitter-gutter) {
	display: none;
}

.content {
	height: 100%;
	width: 100%;
	display: flex;
	overflow: hidden;
	flex-flow: column nowrap;
}

.content-error-messages {
	padding: 0.5rem 1rem 0.5rem 1rem;
}

.scroll-content {
	flex: 1 1 0;
	align-self: auto;
	height: 100%;
	overflow-y: auto;
}

.validation-table-panel {
	position: relative;
	min-height: 0;
}

.validation-table-panel-v2 {
	overflow: hidden;
}

.validation-table-loading {
	height: 100%;
}

.validation-table-hidden {
	visibility: hidden;
	pointer-events: none;
}

.content ::v-deep(.p-tabview .p-tabview-panels) {
	overflow-y: auto;
}

.viewer {
	height: 100%;
	width: 100%;
}

.root-splitter::v-deep(.p-splitter-gutter) {
	height: 10px;
}

// The nested horizontal Splitter has no width of its own (default flex-grow: 0, overflow:
// visible), so at narrow window widths it sizes to its content's min-width instead of the
// panel it's in, throwing off the left/right split ratio before .p-splitter-panel's own
// overflow: hidden ever gets a chance to clip cleanly. Stretching it to fill the panel and
// letting it shrink below content size defers overflow handling to what's inside it.
::v-deep(.p-splitter-panel-nested > .p-splitter) {
	flex: 1 1 0;
	min-width: 0;
}

::v-deep(.p-splitter-panel-nested .p-splitter-gutter) {
	width: 10px;
	height: 100%;
}

::v-deep(.p-splitter-gutter-handle) {
	background: var(--dex-primary-color) !important;
	width: 5% !important;
	height: 1.875rem !important;
	border-top-right-radius: 1rem;
	border-top-left-radius: 1rem;
	position: sticky;
	cursor: pointer;
	transform: scale(1);
}

::v-deep(.p-splitter-panel-nested .p-splitter-gutter-handle) {
	width: 1.5rem !important;
	border-top-right-radius: 0;
	border-top-left-radius: 0;
	position: unset;
	cursor: col-resize;
}

::v-deep(.p-splitter-gutter-handle:focus) {
	box-shadow: none;
}

::v-deep(.p-scrollpanel-content) {
	padding: 0 18px 20px 0;
}

/* width & height  */
::-webkit-scrollbar {
	width: 0.525rem;
	height: 0.75rem;
}

/* Track */
::-webkit-scrollbar-track {
	background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: var(--dex-primary-light-color);
	border-radius: 0.525rem;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: var(--dex-primary-color);
}

@media only screen and (max-width: 920px) {
	.p-button.p-button-icon-only {
		width: 2rem;
	}
}

.p-button.p-button-icon-only {
	width: 2.5rem;
}

::v-deep(.p-message) {
	width: 100%;
	margin: 0 0 0.5rem 0;
}

::v-deep(.p-message .p-message-wrapper) {
	padding: 0 1rem 0 1rem;
}

::v-deep(.p-message .p-message-text) {
	width: 100%;
}

::v-deep(.p-message.p-message-error .p-message-icon) {
	display: none;
}

::v-deep(.p-message.p-message-success .p-message-icon) {
	display: none;
}

::v-deep(.p-message.p-message-warn .p-message-icon) {
	display: none;
}

.horizontal-line {
	width: 100%;
	border: 0.063rem solid var(--surface-300);
	margin: 0;
}

.dragFiles {
	height: 100vh;
	width: 100%;
	text-align: center;
	border: 2px dashed #000;
	background: var(--dex-secondary-background-color);
	display: none;
	position: fixed; top: 0; left: 0;
	z-index: 9999999999;
	margin-top: 0px;
	margin-bottom: 0px;
}

.drag {
	display: block;
}

.dragContainer{
	position: relative;
}

.uploadDragImage {
	position: absolute;
	bottom: 10rem;
	font-size: 10rem;
}

::v-deep(.p-tabview-panel) {
	overflow-x: hidden;
}

.p-grid.p-jc-between.errorMessages {
	margin-right: 0rem;
	margin-left: 0rem;
	margin-top: 0rem;
}

.restrict-height {
	height: calc(100% - 4.125rem); // 4.125rem = 66px = height of the toolbar + line + bottom divider
}

</style>
